<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
        <hr class="my-4">

        <div>
            <!-- <b-form-input
      list="my-list-id"
      type="text"
      placeholder="Busca por documento"
      @input="handleInputChange"
    ></b-form-input> -->
            <datalist id="my-list-id">
                <option v-for="size in sizes" :value="size.identificacion" :key="size.id">
                    {{ size.nombre }}
                </option>
            </datalist>

            <datalist id="diagnosticos-list">
                <option v-for="diagnostico in diagnosticosFiltrados" :value="diagnostico.searchText"
                    :key="diagnostico.id">
                    {{ diagnostico.searchText }}
                </option>
            </datalist>
        </div>
        <b-card class="butonopcionesMS" v-b-toggle="['collapsea']">Pacientes <b-icon class="felchasicono"
                icon="chevron-down" /></b-card>

        <b-collapse visible v-model="isCollapsed" id="collapsea" class="mt-2">
            <b-card>
                <b-overlay :show="buscandoPaciente" rounded="sm" opacity="0.6">
                    <template #overlay>
                        <div class="text-center">
                            <b-spinner variant="primary" style="width: 2rem; height: 2rem;"></b-spinner>
                            <p class="mt-2 mb-0" style="color: #007bff; font-weight: 600;">Buscando paciente...</p>
                        </div>
                    </template>
                    <vue-form-generator :schema="schema" :model="model" :options="formOptions"
                        ref="newMemberForm"></vue-form-generator>
                </b-overlay>
            </b-card>
        </b-collapse>
        <b-card class="butonopcionesMS" v-b-toggle="['collapseb']">Equipos <b-icon class="felchasicono"
                icon="chevron-down" /></b-card>
        <b-collapse visible id="collapseb" class="mt-2">
            <b-card>
                <vue-form-generator :schema="schema1" :model="model" :options="formOptions"
                    ref="newMemberForm1"></vue-form-generator>

            </b-card>
        </b-collapse>
        <b-card class="butonopcionesMS" v-b-toggle="['collapsec']">Medio de administración <b-icon class="felchasicono"
                icon="chevron-down" /></b-card>
        <b-collapse visible id="collapsec" class="mt-2">
            <b-card>
                <vue-form-generator :schema="schema2" :model="model" :options="formOptions"
                    ref="newMemberForm2"></vue-form-generator>

            </b-card>
        </b-collapse>

        <b-card class="butonopcionesMS" v-b-toggle="['collapsed']">Diagnóstico<b-icon class="felchasicono"
                icon="chevron-down" /></b-card>
        <b-collapse visible id="collapsed" class="mt-2">
            <b-card>
                <vue-form-generator :schema="schema3" :model="model" ref="newMemberForm3"
                    :options="formOptions"></vue-form-generator>

            </b-card>
        </b-collapse>
        <b-alert class="alertaroja" @dismissed="disiss = 0" @dismiss-count-down="disissDownChanged" dismissible
            variant="danger" :show="disiss">{{ mensajeerror }}</b-alert>

        <b-alert v-if="alertA" class="alertaroja" show variant="danger">
            {{ alertText }}
        </b-alert>

        <!-- Alerta de solicitud devuelta con motivo de rechazo -->
        <b-alert v-if="correccion && motivoRechazoTexto" show variant="warning" class="mt-3">
            <h5><b-icon icon="exclamation-triangle-fill"></b-icon> Solicitud devuelta por el prestador</h5>
            <p><strong>Motivo:</strong> {{ motivoRechazoTexto }}</p>
            <p v-if="detalleRechazoTexto"><strong>Detalle:</strong> {{ detalleRechazoTexto }}</p>
            <p v-if="observacionesRechazoTexto"><strong>Observaciones:</strong> {{ observacionesRechazoTexto }}</p>
            <hr>
            <p class="mb-0">Corrija los datos necesarios y presione <strong>"Corregir y reenviar"</strong> para enviar
                la solicitud nuevamente.</p>
        </b-alert>

        <b-badge v-for="(imageUrl, index) in cantidadImg" :key="index" class="badge-dismissible b-imagens ml-5"
            variant="info" @click="openImage(imageUrl)">
            {{ imageUrl.name }}
        </b-badge>



        <!-- Botones para cuando es editable (Cliente/Prestador editando o Super Administrador) -->
        <div v-if="!this.esPerfilSoloConsulta && ((this.proveerdor != 1 && this.editar != 1) || (this.prestador == 1 && this.editar == 1) || this.esSuperAdmin)"
            class="centro">
            <div>
                <!-- Botón de Corregir y Reenviar (solo en modo corrección) -->
                <b-button v-if="this.correccion == true" @click="corregirSolicitud" class="botonregidtro"
                    variant="warning">
                    <span v-if="this.load == false" class="ingresar poppins-semi-bold-white-14px">
                        <b-icon icon="pencil-square"></b-icon> Corregir y reenviar
                    </span>
                    <div v-if="this.load == true">
                        <b-spinner small></b-spinner><span
                            class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span>
                    </div>
                </b-button>
                <b-button v-else-if="this.editable == true || this.esSuperAdmin" @click="editarSolicitudCliente" class=" botonregidtro"><span
                        v-if="this.load == false" class="ingresar poppins-semi-bold-white-14px">Editar</span>
                    <div v-if="this.load == true">
                        <b-spinner small></b-spinner><span
                            class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span>
                    </div>

                </b-button>
                <b-button v-else @click="enviarSolicitudCliente" class=" botonregidtro"><span v-if="this.load == false"
                        class="ingresar poppins-semi-bold-white-14px">Enviar</span>

                    <div v-if="this.load == true">
                        <b-spinner small></b-spinner><span
                            class="sr-only ingresar poppins-semi-bold-white-14px">Cargando...</span>
                    </div>

                </b-button>

            </div>
        </div>

        <!-- Botones para Proveedor viendo detalle (solo visualización) -->
        <div class="centro">
            <b-row class="mt-3">
                <b-col cols="12" md="6" class="mb-2">
                    <b-button @click="exportarAExcel" variant="success" class="w-100">
                        <b-icon icon="file-earmark-excel" aria-hidden="true"></b-icon> Exportar a Excel
                    </b-button>
                </b-col>
                <b-col cols="12" md="6" class="mb-2">
                    <b-button @click="copiarAlPortapapeles" variant="info" class="w-100">
                        <b-icon icon="clipboard" aria-hidden="true"></b-icon> Copiar al portapapeles
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <!-- Mensaje de copiado exitoso -->
        <b-alert v-model="mostrarAlertaCopia" variant="success" dismissible fade class="mt-3">
            ¡Datos copiados al portapapeles exitosamente!
        </b-alert>
        <b-modal centered hide-footer no-close-on-backdrop no-close-on-esc hide-header v-model="bloqueo"
            title="Crear solicitud">
            <ModalAcepp :mensaje="mensaje" :ruta="ruta" :boton="boton" />

        </b-modal>

        <!-- Modal de Error -->
        <b-modal centered hide-footer no-close-on-backdrop no-close-on-esc hide-header v-model="modalError"
            title="Error">
            <div class="text-center">
                <b-icon icon="exclamation-triangle" variant="danger" font-scale="3"></b-icon>
                <h4 class="mt-3 text-danger">Error en la solicitud</h4>
                <p class="mt-3">{{ mensajeError }}</p>
                <b-button variant="danger" @click="cerrarModalError" class="mt-3">
                    Aceptar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import ModalAcepp from "../../components/ModalAcep.vue";
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";
import * as XLSX from 'xlsx';
import cie10Catalogo from '../../data/cie10.json';

Vue.use(VueFormGenerator)

const clientes = RepositoryFactory.get("clientes");
const config = RepositoryFactory.get("config");
export default {
    components: {
        "vue-form-generator": VueFormGenerator.component,
        ModalAcepp,
        HeaderGeneral
    },
    watch: {
        "model.lugar"(newValue) {
            // Actualizar visibilidad de los campos de equipos según el lugar seleccionado
            const equiposDomicilioIndex = 1; // Índice del campo 'Equipos en Domicilio'
            const equiposInstitucionIndex = 2; // Índice del campo 'Equipos en la institución'
            const homologDomicilioIndex = 13; // Índice del campo 'Equipos en Domicilio (Homologación)'
            const homologInstitucionIndex = 14; // Índice del campo 'Equipos en la institución (Homologación)'

            const hasHomologDomicilio = Array.isArray(this.model.elementos_homologacion) && this.model.elementos_homologacion.length > 0;
            const hasHomologInstitucion = Array.isArray(this.model.elementos_institucion_homologacion) && this.model.elementos_institucion_homologacion.length > 0;
            
            // Determinar si es proveedor puro (no prestador)
            const esPuroProv = this.proveerdor == 1 && this.prestador != 1;
            
            // Determinar si estamos en modo visualización (viene del dashboard)
            // En modo visualización, TODOS los roles deben poder ver homologación si existe
            const esVisualizacion = !this.idSolicitudBloqueada; // Si no hay bloqueo, es visualización

            if (newValue == 1) { // Entrega en domicilio
                // Mostrar campos originales solo si:
                // - No es proveedor puro, O
                // - Es proveedor puro pero no hay homologación disponible
                this.schema1.fields[equiposDomicilioIndex].visible = esPuroProv ? !hasHomologDomicilio : true;
                this.schema1.fields[equiposInstitucionIndex].visible = false;
                
                // Mostrar campos de homologación si:
                // - Es prestador (siempre), O
                // - Es proveedor puro con datos de homologación, O
                // - Es modo visualización Y hay datos de homologación (para cualquier rol)
                this.schema1.fields[homologDomicilioIndex].visible = 
                    this.prestador == 1 ? true : 
                    (esPuroProv && hasHomologDomicilio) || 
                    (esVisualizacion && hasHomologDomicilio);
                this.schema1.fields[homologDomicilioIndex].styleClasses = 'col-md-4 offset-md-4 campo-homologacion';
                this.schema1.fields[homologInstitucionIndex].visible = false;
                // Limpiar el campo de institución si no es visible
                this.model.elementos_institucion = null;
            } else if (newValue == 2) { // Entrega en institución
                this.schema1.fields[equiposDomicilioIndex].visible = false;
                this.schema1.fields[equiposInstitucionIndex].visible = esPuroProv ? !hasHomologInstitucion : true;
                this.schema1.fields[homologDomicilioIndex].visible = false;
                
                // Mostrar campos de homologación si:
                // - Es prestador (siempre), O
                // - Es proveedor puro con datos de homologación, O
                // - Es modo visualización Y hay datos de homologación (para cualquier rol)
                this.schema1.fields[homologInstitucionIndex].visible = 
                    this.prestador == 1 ? true : 
                    (esPuroProv && hasHomologInstitucion) || 
                    (esVisualizacion && hasHomologInstitucion);
                this.schema1.fields[homologInstitucionIndex].styleClasses = 'col-md-4 offset-md-8 campo-homologacion';
                // Limpiar el campo de domicilio si no es visible
                this.model.elementos = null;
            } else if (newValue == 3) { // Domicilio e Institución
                this.schema1.fields[equiposDomicilioIndex].visible = esPuroProv ? !hasHomologDomicilio : true;
                this.schema1.fields[equiposInstitucionIndex].visible = esPuroProv ? !hasHomologInstitucion : true;
                
                // Mostrar campos de homologación domicilio
                this.schema1.fields[homologDomicilioIndex].visible = 
                    this.prestador == 1 ? true : 
                    (esPuroProv && hasHomologDomicilio) || 
                    (esVisualizacion && hasHomologDomicilio);
                this.schema1.fields[homologDomicilioIndex].styleClasses = 'col-md-4 offset-md-4 campo-homologacion';
                
                // Mostrar campos de homologación institución
                this.schema1.fields[homologInstitucionIndex].visible = 
                    this.prestador == 1 ? true : 
                    (esPuroProv && hasHomologInstitucion) || 
                    (esVisualizacion && hasHomologInstitucion);
                this.schema1.fields[homologInstitucionIndex].styleClasses = 'col-md-4 campo-homologacion';
            } else {
                // Si no hay lugar seleccionado, ocultar ambos
                this.schema1.fields[equiposDomicilioIndex].visible = false;
                this.schema1.fields[equiposInstitucionIndex].visible = false;
                this.schema1.fields[homologDomicilioIndex].visible = false;
                this.schema1.fields[homologInstitucionIndex].visible = false;
                this.model.elementos = null;
                this.model.elementos_institucion = null;
            }
        },
        "model.edad"(newValue) {
            if (newValue) {
                // Calcular la edad cuando cambie la fecha
                this.calcularEdad(newValue);

                console.log("Fecha de nacimiento recibida:", newValue);

                // Manejar fecha en formato YYYY-MM-DD directamente sin problemas de zona horaria
                if (newValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    const [year, month, day] = newValue.split('-');

                    // Formatear la fecha a 'DD/MM/YYYY' para consistencia con el formato string esperado
                    const fechaFormateada = `${day}/${month}/${year}`;
                    console.log("Fecha de nacimiento convertida:", fechaFormateada);

                    // Asignar la fecha convertida
                    this.model.fechaConvertida = fechaFormateada;
                } else {
                    // Si no está en formato esperado, intentar como fecha
                    const fecha = new Date(newValue);
                    if (!isNaN(fecha.getTime())) {
                        const day = fecha.getDate().toString().padStart(2, '0');
                        const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
                        const year = fecha.getFullYear();
                        const fechaFormateada = `${day}/${month}/${year}`;
                        this.model.fechaConvertida = fechaFormateada;
                    } else {
                        this.model.fechaConvertida = '';
                        console.error("El valor no es una fecha válida:", newValue);
                    }
                }
            } else {
                // Si no hay valor, vaciar ambos campos
                this.model.fechaConvertida = '';
                this.model.edad_calculada = null;
                console.log("Fecha de nacimiento eliminada o no establecida.");
            }
            console.log("Fecha de nacimiento convertida final:", this.model.fechaConvertida);
        },
        selectedValue(newValue) {
            console.log("Selected Value:", newValue);
        },
        "model.nombreinstitucion"(newValue) {
            if (newValue && typeof newValue === 'string') {
                // Evitar loop infinito verificando si ya está en mayúsculas
                const upperValue = newValue.toUpperCase();
                if (newValue !== upperValue) {
                    this.$nextTick(() => {
                        this.model.nombreinstitucion = upperValue;
                    });
                }
            }
        },
        "model.tipo_paciente"(newValue) {
            // Actualizar las opciones de dosis cuando cambia el tipo de paciente
            const dosisFieldIndex = 8; // Índice del campo de dosis en schema1
            if (newValue === 'pediatrico') {
                this.schema1.fields[dosisFieldIndex].values = this.valoresdosisPediatrico;
            } else if (newValue === 'adulto') {
                this.schema1.fields[dosisFieldIndex].values = this.valoresdosisAdulto;
            } else {
                // Si no hay tipo seleccionado, dejar vacío
                this.schema1.fields[dosisFieldIndex].values = [];
            }
        },
        "model.tiempo"(newValue) {
            // Cuando cambia el tiempo de revisión médica, mostrar la fecha de valoración calculada
            if (newValue && newValue !== '' && newValue !== '0' && newValue !== 0) {
                const fechaValoracion = this.calcularFechaValoracion(newValue);
                if (fechaValoracion) {
                    console.log(`📅 Fecha de valoración calculada: ${fechaValoracion} (Fecha actual + ${newValue} días)`);
                }
            }
        },
        "model.afiliacion"(newValue) {
            const nivelActual = this.model.nivel_ingreso;
            this.actualizarOpcionesNivelIngreso(newValue);
            // Si ya había un valor y sigue siendo válido para la nueva afiliación, restaurarlo
            const nivelIngresoFieldIndex = 26;
            const opcionesValidas = (this.schema.fields[nivelIngresoFieldIndex].values || []).map(v => v.id);
            if (nivelActual && opcionesValidas.includes(nivelActual)) {
                this.model.nivel_ingreso = nivelActual;
            }
        },
    },
    data() {
        return {
            cantidadImg: 0,
            imageUrls: [],
            estructura: {},
            alertA: false,
            alertText: "",
            valorestypevia: [],
            valorestypeinmueble: [],
            valoresbloque: [],
            valoresmacara: [{
                id: 1,
                name: "Nasal"
            }, {
                id: 2,
                name: "Oronasal"
            }],
            valorescie: [{
                id: 1,
                name: "CIE-10"
            }],
            diagnosticosFiltrados: [],
            valoreps: [{
                id: 1,
                name: "EPS"
            }],
            valortalla: [],
            valorgenero: [],
            valoresdosisPediatrico: [
                { id: "1/64 LPM", name: "1/64 LPM" },
                { id: "1/32 LPM", name: "1/32 LPM" },
                { id: "1/16 LPM", name: "1/16 LPM" },
                { id: "1/8 LPM", name: "1/8 LPM" },
                { id: "1/4 LPM", name: "1/4 LPM" },
                { id: "0.5 LPM", name: "0.5 LPM" },
                { id: "1 LPM", name: "1 LPM" },
                { id: "2 LPM", name: "2 LPM" },
                { id: "3 LPM", name: "3 LPM" }
            ],
            valoresdosisAdulto: [
                { id: "1 LPM", name: "1 LPM" },
                { id: "2 LPM", name: "2 LPM" },
                { id: "3 LPM", name: "3 LPM" },
                { id: "4 LPM", name: "4 LPM" },
                { id: "5 LPM", name: "5 LPM" },
                { id: "6 LPM", name: "6 LPM" },
                { id: "7 LPM", name: "7 LPM" },
                { id: "8 LPM", name: "8 LPM" },
                { id: "9 LPM", name: "9 LPM" },
                { id: "10 LPM", name: "10 LPM" },
                { id: "11 LPM", name: "11 LPM" },
                { id: "12 LPM", name: "12 LPM" },
                { id: "13 LPM", name: "13 LPM" },
                { id: "14 LPM", name: "14 LPM" },
                { id: "15 LPM", name: "15 LPM" }
            ],
            selectedValue: null,
            selectedItem: null,
            sizes: [],
            mensajeerror: "",
            carpeta: null,
            editable: false,
            editar: 0,
            prestador: 0, // Nueva variable para prestador
            esSuperAdmin: false, // Nueva variable para Super Administrador
            esPerfilSoloConsulta: false, // Nueva variable para perfiles de solo consulta (Asegurador, Auditor)
            idSolicitudBloqueada: null, // ID de solicitud bloqueada desde /prestador-recepcion-solicitudes
            buscandoPaciente: false, // Loading al buscar paciente por documento
            correccion: false, // Modo corrección de solicitud devuelta
            motivoRechazoTexto: '', // Texto del motivo de rechazo para mostrar
            detalleRechazoTexto: '', // Detalle del motivo de rechazo
            observacionesRechazoTexto: '', // Observaciones del rechazo
            datoseditar: "",
            isCollapsed: true,
            load: false,
            bloqueo: false,
            mostrarAlertaCopia: false, // Para mostrar mensaje de copiado exitoso
            proveniente: "",
            vista: "",
            mensaje: "",
            ruta: "/mis-solicitudes",
            boton: "Aceptar",
            disiss: 0,
            dis: 10,
            municipios: [],
            entidad: "entidad_solicitud",
            version: "2",
            estado: "",
            idsolicitud: null,
            idpaciente: null,
            archivoAdjunto: "",
            model: {
                tipo_identificacion: null,
                identificacion: "",
                nombre: "",
                edad: null,
                edad_calculada: null,
                nacimiento: null,
                genero: "",
                nacionalidad: "Colombiana",
                talla: "",
                departamento: null,
                municipio: null,
                barrio: null,
                telefono1: null,
                telefono2: 0,
                telefono3: 0,
                cobertura: null,
                afiliacion: null,
                nivel_ingreso: null,
                ips_paciente: null,
                elementos: null,
                elementos_institucion: null,
                elementos_homologacion: null,
                elementos_institucion_homologacion: null,
                dosis: null,
                tipo_paciente: null,

                lugar: null,
                nombreinstitucion: null,
                direccionequipos: "",
                detalleequipos: "",
                medioadmin: null,
                horas: "",
                diagnostico: "",
                cie: "",
                tiempo: null,
                obsevacion: "",
                typevia: "", // Nuevo campo para "Tipo de vía"
                number: null,
                number1: null,
                number2: null,
                typeinmueble: "",
                number3: "",
                bloque: 0,
                number4: "",
                eps: "",
                namecontacto: "",
                email: "",
                obsevacionContact: "",
                typemascara: "",
                lugarEntrega: "",
                nombreInstitucion: "",
                horas: "",
                doctor: "",
                tipo_documento_medico: "",
                numero_documento_medico: "",
                email_institucion: "",
                documento_adjunto: null,
                obsevacion: "",
            },
            schema: {
                fields: [{
                    type: 'select',
                    label: 'Tipo de Identificación ',
                    model: 'tipo_identificacion',
                    placeholder: "Select your favorite library",
                    values: [],
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-5 arrow',
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',
                        hideNoneSelectedText: false,
                        tagPlaceholder: "tagPlaceholder",
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Proveedor puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },


                },

                {
                    type: 'input',
                    inputType: 'number',
                    inputName: 'identificacion',
                    label: 'Número de identificación',
                    list: 'my-list-id',
                    model: 'identificacion',
                    required: (model) => !(this.proveerdor == 1 || this.editar == 1),
                    readonly: false,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Proveedor puede editar
                        return model.tipo_identificacion == '' ||
                            model.tipo_identificacion == undefined ||
                            this.proveerdor == 1 ||
                            this.cliente == 1 ||
                            this.editar == 1;
                    },
                    max: 999999999999999,
                    min: 0,
                    validator: ['required', 'number'],
                    styleClasses: 'offset-md-2 col-md-5',
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo ", newVal);
                        this.handleInputChange(newVal);
                    },
                },

                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "nombre",
                    label: 'Nombre completo',
                    model: 'nombre',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-5 transform:uppercase ',
                    max: 70,
                    validator: ["required", "string"],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputName: "edad",
                    inputType: 'date',
                    label: 'Fecha de nacimiento',
                    model: 'edad',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'offset-md-2 col-md-5',
                    onChanged: (model, newVal, oldVal, field) => {
                        this.calcularEdad(newVal);
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'number',
                    inputName: "edad_calculada",
                    label: 'Edad (años)',
                    model: 'edad_calculada',
                    readonly: true,
                    styleClasses: 'col-md-2',
                    disabled: true,
                    placeholder: 'Se calcula automáticamente',
                },
                {
                    type: 'select',
                    label: 'Genero',
                    model: 'genero',
                    values: [],
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'offset-md-2 col-md-3 transform:uppercase',
                    validator: ["required"],
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo depa");
                        this.municipioXDepartamento(model.departamento);
                    },
                    selectOptions: {

                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "nacionalidad",
                    label: 'Nacionalidad',
                    model: 'nacionalidad',
                    styleClasses: 'offset-md-2 col-md-2 transform:uppercase ',
                    max: 70,
                    validator: ["required", "string"],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },

                {
                    type: 'select',
                    label: 'Departamento',
                    model: 'departamento',
                    values: [],
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-5 transform:uppercase  arrow',
                    validator: ["required"],
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo depa");
                        this.municipioXDepartamento(model.departamento);
                    },
                    selectOptions: {

                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'select',
                    label: 'Municipio',
                    model: 'municipio',
                    values: [],
                    dependencies: ["departamento"],
                    options: {},
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'offset-md-2 col-md-5 arrow',
                    validator: ["required"],
                    icon: 'home',
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (model.departamento == '' || model.departamento == undefined || this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',

                    },
                },
                {
                    type: 'select',
                    label: 'Tipo de via',
                    model: 'typevia',
                    values: [],
                    required: false, // Campo no requerido
                    styleClasses: '  col-md-3 transform:uppercase  arrow',
                    validator: [], // Sin validadores requeridos
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo depa");
                        this.municipioXDepartamento(model.departamento);
                    },
                    selectOptions: {

                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },

                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Número ',
                    inputName: "number",
                    model: 'number',
                    required: false,
                    styleClasses: 'offset-md-1 col-md-2 arrow',
                    max: 70,
                    validator: [],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Número',
                    inputName: "number1",
                    model: 'number1',
                    required: false,
                    styleClasses: 'offset-md-1 col-md-2 arrow',
                    max: 70,
                    validator: [],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Número',
                    inputName: "number2",
                    model: 'number2',
                    required: false,
                    styleClasses: 'offset-md-1 col-md-2 arrow',
                    max: 70,
                    validator: [],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'select',
                    label: 'Tipo de inmueble',
                    model: 'typeinmueble',
                    values: [],
                    required: false,
                    styleClasses: '  col-md-3 transform:uppercase  arrow',
                    validator: [],
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo depa");
                        this.municipioXDepartamento(model.departamento);
                    },
                    selectOptions: {

                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },

                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Número/Nombre',
                    inputName: "number3",
                    model: 'number3',
                    styleClasses: 'offset-md-1 col-md-2 arrow',
                    max: 70,
                    validator: [],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'select',
                    label: 'Bloque o interior',
                    model: 'bloque',
                    values: [],
                    styleClasses: 'offset-md-1 col-md-2 transform:uppercase  arrow',
                    validator: [],
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo depa");
                        this.municipioXDepartamento(model.departamento);
                    },
                    selectOptions: {

                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'Número/Nombre',
                    inputName: "number4",
                    model: 'number4',
                    styleClasses: ' offset-md-1 col-md-2 arrow',
                    max: 70,
                    validator: [],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "barrio",
                    label: 'Barrio , Localidad o Sector',
                    model: 'barrio',
                    required: true,
                    styleClasses: 'transform:uppercase ',
                    max: 70,
                    validator: [],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'number',
                    inputName: "telefono",
                    label: 'Telefono 1 ',
                    model: 'telefono1',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-4',
                    max: 70,
                    min: 0,
                    validator: ["required"],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                }, {
                    type: 'input',
                    inputType: 'number',
                    label: 'Telefono 2 ',
                    inputName: "telefono2",
                    model: 'telefono2',
                    required: false,
                    styleClasses: 'offset-md-1 col-md-3',
                    max: 70,
                    min: 0,
                    validator: ["required"],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                }, {
                    type: 'input',
                    inputType: 'number',
                    inputName: "telefono3",
                    label: 'Telefono 3 ',
                    model: 'telefono3',
                    required: false,
                    styleClasses: 'offset-md-1 col-md-3',
                    max: 70,
                    min: 0,
                    validator: ["required"],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'select',
                    label: 'Eps',
                    model: 'eps',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    values: [],
                    styleClasses: 'col-md-3 transform:uppercase arrow ',
                    max: 70,
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        // Deshabilitado por defecto, solo habilitado en casos específicos
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return true; // Deshabilitado por defecto
                    },
                },
                {
                    type: 'select',
                    label: 'Cobertura',
                    model: 'cobertura',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    values: [],
                    styleClasses: 'offset-md-1 col-md-3 transform:uppercase arrow ',
                    max: 70,
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        // Deshabilitado por defecto, solo habilitado en casos específicos
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return true; // Deshabilitado por defecto
                    },
                },
                {
                    type: 'select',
                    label: 'Afiliación',
                    model: 'afiliacion',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    max: 70,
                    values: [],
                    styleClasses: 'offset-md-2 col-md-3 arrow',
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin || this.prestador == 1) return false; // Super Administrador puede editar todos los campos
                        //if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "namecontacto",
                    label: 'Nombre del contacto',
                    model: 'namecontacto',
                    styleClasses: '  col-md-5  ',
                    max: 70,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "email",
                    label: 'Correo',
                    model: 'email',
                    styleClasses: ' offset-md-2 col-md-5   arrow',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    max: 70,
                    validator: ["required", "string"],
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'select',
                    label: 'Nivel de ingreso',
                    model: 'nivel_ingreso',
                    values: [],
                    styleClasses: 'offset-md-2 col-md-3 arrow',
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',
                    },
                    visible: () => this.prestador == 1 || this.proveerdor == 1,
                    disabled: () => this.prestador != 1,
                },
                {
                    type: 'input',
                    inputType: 'text',
                    label: 'IPS del paciente',
                    model: 'ips_paciente',
                    styleClasses: 'offset-md-2 col-md-3',
                    visible: () => this.prestador == 1 || this.proveerdor == 1,
                    disabled: () => this.prestador != 1,
                    onChanged: (model, newVal, oldVal, field) => {
                        if (newVal && typeof newVal === 'string') {
                            this.model.ips_paciente = newVal.toUpperCase();
                        }
                    },
                },
                {
                    type: 'textArea',
                    inputType: 'text',
                    label: 'Observaciones del paciente',
                    model: 'obsevacionContact',
                    required: false,
                    styleClasses: '',
                    max: 500,
                    rows: 6,
                    cols: 30,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.prestador == 1) return true; // Prestador NO puede editar datos del paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                    // validator: ["required",],
                },
                ]
            },
            schema1: {
                fields: [{
                    type: 'select',
                    inputName: "lugarEntrega",
                    values: [],
                    label: 'Lugar de entrega',
                    model: 'lugar',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    readonly: false,
                    disabled: false,
                    max: 15,
                    validator: ["required"],
                    styleClasses: 'col-md-4 arrow',
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },

                },
                {
                    type: 'checklist',
                    label: 'Equipos en Domicilio',
                    model: 'elementos',
                    multi: true,
                    styleClasses: 'col-md-4',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        // Solo requerido si el lugar es domicilio (1) o ambos (3)
                        return model.lugar == 1 || model.lugar == 3;
                    },
                    validator: ["required"],
                    values: [],
                    checklistOptions: {
                        value: "id"
                    },
                    visible: function (model) {
                        // Visible si es entrega en domicilio (1) o ambos (3)
                        return model.lugar == 1 || model.lugar == 3;
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },

                },
                {
                    type: 'checklist',
                    label: 'Equipos en la institución',
                    model: 'elementos_institucion',
                    multi: true,
                    styleClasses: 'col-md-4',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        // Solo requerido si el lugar es institución (2) o ambos (3)
                        return model.lugar == 2 || model.lugar == 3;
                    },
                    validator: ["required"],
                    values: [],
                    checklistOptions: {
                        value: "id"
                    },
                    visible: function (model) {
                        // Visible si es entrega en institución (2) o ambos (3)
                        return model.lugar == 2 || model.lugar == 3;
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },

                },
                {
                    type: 'select',
                    inputName: "typemascara",
                    values: [],
                    label: 'Tipo mascara',
                    model: 'typemascara',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    readonly: false,
                    disabled: false,
                    max: 15,
                    validator: ["required"],
                    styleClasses: 'offset-md-2 col-md-2 transform:uppercase',
                    selectOptions: {
                        noneSelectedText: 'Seleccione una opción',
                    },
                    visible: false, // Campo oculto - no se necesita en ingreso
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },

                },
                {
                    type: 'select',
                    label: 'Talla mascara',
                    model: 'talla',
                    values: [],
                    styleClasses: 'offset-md-2 col-md-2 transform:uppercase ',
                    validator: ["required"],
                    visible: false, // Campo oculto - no se necesita en ingreso
                    onChanged: (model, newVal, oldVal, field) => {
                        console.log("paooo depa");
                        this.municipioXDepartamento(model.departamento);
                    },
                    selectOptions: {

                        noneSelectedText: 'Seleccione una opción',

                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "nombreInstitucion",
                    label: 'Nombre institución',
                    model: 'nombreinstitucion',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-3 offset-md-1',
                    inputClass: 'text-uppercase',
                    maxlength: 70,
                    validator: ["required"],
                    // visible: function (model) {
                    //     //visible if business is selected
                    //     return model.lugar == 2;
                    // },
                    visible: true,
                    placeholder: 'Ingrese el nombre de la institución',
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },


                },
                {
                    type: 'input',
                    inputType: 'email',
                    inputName: "email_institucion",
                    label: 'Correo institución (Correo donde se contestan solicitudes)',
                    model: 'email_institucion',
                    required: true,
                    styleClasses: 'col-md-7',
                    max: 70,
                    validator: ["email"],
                    visible: true,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'select',
                    inputName: "tipo_paciente",
                    label: 'Tipo de paciente',
                    model: 'tipo_paciente',
                    required: true,
                    values: [
                        { id: 'pediatrico', name: 'Pediátrico' },
                        { id: 'adulto', name: 'Adulto' }
                    ],
                    styleClasses: 'col-md-4 offset-md-1',
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione el tipo',
                    },
                    visible: true,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1) return true;
                        return false;
                    },
                    onChanged: (model, newVal, oldVal, field) => {
                        // Limpiar el valor de dosis al cambiar el tipo de paciente
                        model.dosis = null;

                        // Actualizar los valores del campo de dosis según el tipo seleccionado
                        const dosisFieldIndex = 8; // Índice del campo de dosis en schema1
                        if (newVal === 'pediatrico') {
                            this.schema1.fields[dosisFieldIndex].values = this.valoresdosisPediatrico;
                        } else if (newVal === 'adulto') {
                            this.schema1.fields[dosisFieldIndex].values = this.valoresdosisAdulto;
                        }
                    },
                },
                {
                    type: 'select',
                    inputName: "dosis",
                    label: 'Dosis (LPM - Litros por minuto)',
                    model: 'dosis',
                    required: true,
                    values: [],
                    styleClasses: 'col-md-3 arrow',
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione la dosis',
                    },
                    visible: true,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        // Deshabilitado si no se ha seleccionado tipo de paciente
                        if (this.proveerdor == 1 && this.editar == 1) return false;
                        if (this.proveerdor == 1) return true;
                        if (!model.tipo_paciente) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'number',
                    label: 'Hora',
                    model: 'hora',
                    required: false, // Campo no obligatorio
                    max: 99,
                    min: 0,
                    styleClasses: 'col-md-4',
                    validator: ["number"], // Removido "required"
                    visible: false,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {

                    type: 'input',
                    inputType: 'text',
                    label: 'Presión',
                    inputName: "presion",
                    model: 'presion',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-4',
                    max: 70,
                    visible: false,
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {

                    type: 'input',
                    inputType: 'text',
                    label: 'Dirección institución',
                    inputName: "direccionequipos",
                    model: 'direccionequipos',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    styleClasses: 'col-md-8 offset-md-1',
                    max: 70,
                    visible: function (model) {
                        //visible if business is selected
                        return model.lugar == 2 || model.lugar == 3;
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'input',
                    inputType: 'text',
                    inputName: "detalleequipos",
                    label: 'Detalle (piso, habitación) institución',
                    model: 'detalleequipos',
                    required: false,
                    styleClasses: 'offset-md-1 col-md-8',
                    max: 70,
                    visible: function (model) {
                        //visible if business is selected
                        return model.lugar == 2 || model.lugar == 3;
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.editar == 1) return true;
                        return false;
                    },
                },
                {
                    type: 'checklist',
                    label: 'Equipos en Domicilio (Homologación)',
                    model: 'elementos_homologacion',
                    multi: true,
                    styleClasses: 'col-md-4 offset-md-4 campo-homologacion',
                    required: false,
                    values: [],
                    checklistOptions: {
                        value: "id"
                    },
                    visible: false, // Se controla dinámicamente según rol y lugar
                    disabled: (model) => {
                        // Solo el prestador con bloqueo adquirido puede editar (viene de /prestador-recepcion-solicitudes)
                        if (this.prestador == 1 && this.idSolicitudBloqueada) return false;
                        // Todos los demás roles o prestador sin bloqueo: solo visualización
                        return true;
                    },
                },
                {
                    type: 'checklist',
                    label: 'Equipos en la institución (Homologación)',
                    model: 'elementos_institucion_homologacion',
                    multi: true,
                    styleClasses: 'col-md-4 campo-homologacion',
                    required: false,
                    values: [],
                    checklistOptions: {
                        value: "id"
                    },
                    visible: false, // Se controla dinámicamente según rol y lugar
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        // Solo el prestador con bloqueo adquirido puede editar (viene de /prestador-recepcion-solicitudes)
                        if (this.prestador == 1 && this.idSolicitudBloqueada) return false;
                        // Todos los demás roles o prestador sin bloqueo: solo visualización
                        return true;
                    },
                },



                ]
            },
            schema2: {
                fields: [{
                    type: 'checklist',
                    label: 'Medio de administración ',
                    model: 'medioadmin',
                    "multi": true,
                    styleClasses: ' col-md-5 arrow',
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    validator: ["required"],
                    values: [],
                    checklistOptions: {
                        value: "id",
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },

                {
                    type: 'select',
                    label: 'Horas consumo al día',
                    model: 'horas',
                    inputName: "horas",
                    required: (model) => {
                        if (this.proveerdor == 1 || this.editar == 1) return false;
                        return true;
                    },
                    values: [
                        { id: 16, name: "16 horas" },
                        { id: 17, name: "17 horas" },
                        { id: 18, name: "18 horas" },
                        { id: 19, name: "19 horas" },
                        { id: 20, name: "20 horas" },
                        { id: 21, name: "21 horas" },
                        { id: 22, name: "22 horas" },
                        { id: 23, name: "23 horas" },
                        { id: 24, name: "24 horas" },
                        { id: 25, name: "Uso nocturno" }
                    ],
                    styleClasses: 'col-md-7 arrow',
                    validator: ["required"],
                    selectOptions: {
                        noneSelectedText: 'Seleccione las horas',
                    },
                    disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                        if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                        if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                        return false;
                    },
                },




                ]
            },
            schema3: {
                fields: [
                    {
                        type: 'input',
                        inputType: 'text',
                        inputName: "diagnostico",
                        label: 'CIE-10 Diagnóstico (Escriba para buscar)',
                        model: 'diagnostico',
                        // required:  (model) => {
                        //         if (this.proveerdor == 1 || this.editar == 1) return false;
                        //         return true;
                        //     },
                        required: true,
                        placeholder: 'Escriba código o descripción del diagnóstico...',
                        styleClasses: 'col-md-5',
                        validator: ["required", (value) => {
                            if (!value) return [];
                            const esDiagnosticoValido = this.valorescie.some(cie => cie.searchText === value);
                            return esDiagnosticoValido ? [] : ["Selecciona un diagnóstico de la lista de sugerencias, no se permite texto libre"];
                        }],
                        list: 'diagnosticos-list',
                        onChanged: (model, newVal, oldVal, field) => {
                            this.filterDiagnosticos(newVal);
                        },
                        disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            if (this.proveerdor == 1 && this.editar == 1) return false;
                            if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                            return false;
                        },

                    },
                    {
                        type: 'select',
                        label: 'Dias de formulación',
                        model: 'tiempo',
                        inputName: "tiempo",
                        required: true,
                        values: [
                            { id: 1, name: "1 día" },
                            { id: 2, name: "2 días" },
                            { id: 3, name: "3 días" },
                            { id: 4, name: "4 días" },
                            { id: 5, name: "5 días" },
                            { id: 6, name: "6 días" },
                            { id: 7, name: "7 días" },
                            { id: 8, name: "8 días" },
                            { id: 9, name: "9 días" },
                            { id: 10, name: "10 días" },
                            { id: 11, name: "11 días" },
                            { id: 12, name: "12 días" },
                            { id: 13, name: "13 días" },
                            { id: 14, name: "14 días" },
                            { id: 15, name: "15 días" },
                            { id: 16, name: "16 días" },
                            { id: 17, name: "17 días" },
                            { id: 18, name: "18 días" },
                            { id: 19, name: "19 días" },
                            { id: 20, name: "20 días" },
                            { id: 21, name: "21 días" },
                            { id: 22, name: "22 días" },
                            { id: 23, name: "23 días" },
                            { id: 24, name: "24 días" },
                            { id: 25, name: "25 días" },
                            { id: 26, name: "26 días" },
                            { id: 27, name: "27 días" },
                            { id: 28, name: "28 días" },
                            { id: 29, name: "29 días" },
                            { id: 30, name: "30 días" },
                            { id: 60, name: "60 días (2 meses)" },
                            { id: 90, name: "90 días (3 meses)" },
                            { id: 180, name: "180 días (6 meses)" }
                        ],
                        styleClasses: 'offset-md-2 col-md-5 arrow',
                        validator: ["required"],
                        selectOptions: {
                            noneSelectedText: 'Seleccione los días'
                        },
                        disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            if (this.proveerdor == 1 && this.editar == 1) return false;
                            if (this.proveerdor == 1 || this.cliente == 1 || this.editar == 1) return true;
                            return false;
                        },
                    },
                    {
                        type: 'select',
                        label: 'Tipo de documento médico',
                        model: 'tipo_documento_medico',
                        values: [],
                        // required: (model) => {
                        // if (this.proveerdor == 1 || this.editar == 1) return false;
                        // return true;
                        // },
                        required: true,
                        styleClasses: 'col-md-3 arrow',
                        validator: ["required"],
                        selectOptions: {
                            noneSelectedText: 'Seleccione una opción',
                            hideNoneSelectedText: false,
                            tagPlaceholder: "tagPlaceholder",
                        },
                        disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                            if (this.proveerdor == 1 || this.editar == 1) return true;
                        },
                    },
                    {
                        type: 'input',
                        inputType: 'number',
                        label: 'Número de documento médico',
                        model: 'numero_documento_medico',
                        // required: (model) => {
                        // if (this.proveerdor == 1 || this.editar == 1) return false;
                        // return true;
                        // },
                        required: true,
                        styleClasses: 'offset-md-1 col-md-3',
                        max: 999999999999999,
                        min: 0,
                        validator: ["number"],
                        disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                            if (this.proveerdor == 1 || this.editar == 1) return true;
                        },
                    },
                    {
                        type: 'input',
                        inputType: 'text',
                        label: 'Nombre médico tratante',
                        model: 'doctor',
                        // required: (model) => {
                        // if (this.proveerdor == 1 || this.editar == 1) return false;
                        // return true;
                        // },
                        required: true,
                        styleClasses: 'offset-md-1 col-md-4',
                        max: 50,
                        validator: ["string"],
                        disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            if (this.proveerdor == 1 && this.editar == 1) return false; // Prestador puede editar
                            if (this.proveerdor == 1 || this.editar == 1) return true;
                        },
                    },
                    {
                        type: 'input',
                        inputType: 'file',
                        label: 'Documento Adjunto',
                        model: 'documento_adjunto',
                        id: 'documento_adjunto',
                        required: false,
                        styleClasses: 'col-md-5',
                        validator: ['required'],
                        disabled: (model) => {
                            if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                            if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            return this.proveerdor === 1 || this.editar === 1;
                        },
                        multiple: true,
                        accept: "image/*, application/pdf",
                        onChanged: (model, newVal, oldVal, field) => {
                            const fileInput = document.getElementById(field.id);
                            if (fileInput && fileInput.files && fileInput.files) {
                                const file = fileInput.files;
                                console.log("Archivos seleccionados:", file.length);
                                if (file.length > 2) {
                                    this.showAlert('Solo permite cargar 2 archivos.');
                                    fileInput.value = '';  // Limpiar la selección
                                    this.archivoAdjunto = null;
                                    return // Resetear el valor
                                } else {
                                    this.alertA = false;
                                    console.log("Archivos seleccionados:", file);
                                    this.archivoAdjunto = [];
                                    for (let i = 0; i < file.length; i++) {
                                        this.archivoAdjunto.push(file[i]);
                                    }
                                    console.log(this.archivoAdjunto);

                                }
                            }
                        }
                    },
                    {
                        type: 'textArea',
                        inputType: 'text',
                        label: 'Observaciones',
                        model: 'obsevacion',
                        required: false,
                        styleClasses: '',
                        max: 500,
                        rows: 6,
                        cols: 30,
                        disabled: (model) => {
                        if (this.esPerfilSoloConsulta) return true; // Perfiles de solo consulta no pueden editar
                        if (this.esSuperAdmin) return false; // Super Administrador puede editar todos los campos
                            if (this.proveerdor == 1 && this.editar == 1) return false;
                            if (this.proveerdor == 1 || this.editar == 1) return true;
                            return false;
                        },
                        // validator: ["required",],
                    },

                ]
            },
            formOptions: {

                validateAfterLoad: false,
                validateAfterChanged: true,
                validateAsync: false,
                validationErrorClass: "has-error",
                validationSuccessClass: "has-success",
                i18n: {
                    selected: "seleccionado"
                }
            },

            // Variables para el modal de error
            modalError: false,
            mensajeError: "",


        }

    },
    computed: {

    },
    async beforeDestroy() {
        if (this.idSolicitudBloqueada) {
            try {
                await clientes.desbloquearSolicitud(this.idSolicitudBloqueada);
            } catch (e) {
                console.warn('[bloqueo] No se pudo liberar al salir del detalle:', e);
            }
        }
    },
    async created() {
        try {
            console.log("Ruta params:", this.$route.params);
            this.datoseditar = this.$route.params.myParam;

            this.carpeta = this.$route.params.carpeta;
            if (this.carpeta == undefined || this.carpeta == 'null') {
                this.carpeta = "Clientes";
            }

            //variable para saber que es un provedor
            this.proveerdor = this.$route.params.proveerdor;
            this.cliente = this.$route.params.cliente;

            // Variable para saber que es un prestador
            this.prestador = this.$route.params.prestador;
            // Si venimos desde /prestador-recepcion-solicitudes con bloqueo adquirido, guardar el id
            this.idSolicitudBloqueada = this.$route.params.idSolicitudBloqueada || null;

            console.log("this.$route.params.editable", this.$route.params.editable);
            console.log("this.$route.params.prestador", this.$route.params.prestador);

            this.editar = this.$route.params.editable;
            this.correccion = this.$route.params.correccion || false;
            this.urlenvia = this.$route.params.urlenvia;

            // Detectar si es Super Administrador (perfil #1) o perfil de solo consulta (5=Asegurador, 6=Auditor)
            const datosUser = localStorage.getItem('user');
            if (datosUser) {
                const usuario = JSON.parse(datosUser);
                const idPerfil = usuario.id_perfil;
                
                if (idPerfil === 1) {
                    this.esSuperAdmin = true;
                    console.log('Super Administrador detectado - Habilitando todos los campos para edición');
                }
                
                // Perfiles de solo consulta: 5 (Asegurador) y 6 (Auditor)
                if (idPerfil === 5 || idPerfil === 6) {
                    this.esPerfilSoloConsulta = true;
                    console.log('Perfil de solo consulta detectado (Asegurador/Auditor) - Bloqueando edición');
                }
            }

            const response = await config.listasDesplegables({
                "nombre_entidad": "listados",
            })
            const listaTiposDocumento = response.find(item => item.data.nombre_lista === "Tipos_documento");
            this.valorestipodocumento = listaTiposDocumento.data.rows;
            this.schema.fields[0]['values'] = this.valorestipodocumento

            // Asignar los tipos de documento también al campo del médico (schema3.fields[1] es el tipo documento médico)
            this.schema3.fields[2]['values'] = this.valorestipodocumento

            // Catálogo CIE-10 completo (archivo local, no viene de meta_listados):
            // son ~12.400 códigos fijos que el usuario solo puede seleccionar, nunca
            // escribir libremente. Se evita a propósito el endpoint de listados
            // porque ese catálogo completo ahí volvería lenta cualquier pantalla
            // que cargue desplegables (ver auditoría de queries del backend).
            this.valorescie = cie10Catalogo.map(cie => ({
                ...cie,
                searchText: `${cie.codigo} - ${cie.name}` // Texto combinado para búsqueda
            }));

            this.schema3.fields[0]['values'] = this.valorescie

            // Inicializar diagnósticos filtrados con los primeros 50
            this.diagnosticosFiltrados = this.valorescie.slice(0, 200);

            const listaTiposVia = response.find(item => item.data.nombre_lista === "tipos_via");
            this.valorestypevia = listaTiposVia.data.rows;
            this.schema.fields[9]['values'] = this.valorestypevia

            const listaTiposinmueble = response.find(item => item.data.nombre_lista === "tipos_edificacion");
            this.valorestypeinmueble = listaTiposinmueble.data.rows;
            this.schema.fields[13]['values'] = this.valorestypeinmueble

            const listaTiposBloque = response.find(item => item.data.nombre_lista === "tipos_unidad");
            this.valoresbloque = listaTiposBloque.data.rows;
            this.schema.fields[15]['values'] = this.valoresbloque

            const listaTiposEps = response.find(item => item.data.nombre_lista === "eps_colombia");
            this.valoreps = listaTiposEps.data.rows;
            this.schema.fields[21]['values'] = this.valoreps

            // Establecer valor por defecto para EPS (buscar por nombre específico)
            if (this.valoreps && this.valoreps.length > 0 && !this.model.eps) {
                // Buscar EPS específico por nombre (ejemplo: "SURA", "SANITAS", etc.)
                const epsDefault = this.valoreps.find(eps => eps.name === "EPS Sura");
                if (epsDefault) {
                    this.model.eps = epsDefault.id;
                } else {
                    // Si no encuentra el específico, usar el primer elemento
                    this.model.eps = this.valoreps[0].id;
                }
            }

            const listaTiposTalla = response.find(item => item.data.nombre_lista === "talla");
            this.valortalla = listaTiposTalla.data.rows;
            this.schema1.fields[4]['values'] = this.valortalla

            const listaTiposGenero = response.find(item => item.data.nombre_lista === "genero");
            this.valorgenero = listaTiposGenero.data.rows;
            this.schema.fields[5]['values'] = this.valorgenero

            const listaTiposDepartamentos = response.find(item => item.data.nombre_lista === "divipola_colombia");
            this.valoresdepartamentos = listaTiposDepartamentos.data.rows;
            //


            var departamentos = this.valoresdepartamentos.map(x => {
                return {
                    id: x.codigo_departamento,
                    name: x.nombre_departamento
                }
            }).filter(
                (obj, index, self) =>
                    index ===
                    self.findIndex((o) => o.id === obj.id && o.name === obj.name)
            );
            let arraySinDuplicados = [...new Set(departamentos)];

            this.schema.fields[7]['values'] = arraySinDuplicados
            const listaTiposCobertura = response.find(item => item.data.nombre_lista === "tipos_cobertura");
            this.valorescobertura = listaTiposCobertura.data.rows;
            this.schema.fields[22]['values'] = this.valorescobertura

            // Establecer valor por defecto para Cobertura (buscar PBS/PAC)
            if (this.valorescobertura && this.valorescobertura.length > 0 && !this.model.cobertura) {
                const coberturaDefault = this.valorescobertura.find(cob =>
                    cob.name && cob.name.toUpperCase().includes("PBS") ||
                    cob.name && cob.name.toUpperCase().includes("PAC")
                );
                if (coberturaDefault) {
                    this.model.cobertura = coberturaDefault.id;
                } else {
                    // Si no encuentra PBS/PAC, usar el primer elemento
                    this.model.cobertura = this.valorescobertura[0].id;
                }
            }

            const listaTiposAfiliacion = response.find(item => item.data.nombre_lista === "tipos_afiliacion");
            this.valoresafiliacion = listaTiposAfiliacion.data.rows;
            this.schema.fields[23]['values'] = this.valoresafiliacion

            const listaTiposElementos = response.find(item => item.data.nombre_lista === "elementos");
            this.valoreselementos = listaTiposElementos.data.rows;
            this.schema1.fields[1]['values'] = this.valoreselementos

            // const listaTiposElementos = response.find(item => item.data.nombre_lista === "elementos");
            //this.valoreselementos = listaTiposElementos.data.rows;
            this.schema1.fields[2]['values'] = this.valoreselementos

            const listaTiposElementosHomologados = response.find(item => item.data.nombre_lista === "elementos_homologados");
            this.valoreselementos_homologados = listaTiposElementosHomologados ? listaTiposElementosHomologados.data.rows : [];
            this.schema1.fields[13]['values'] = this.valoreselementos_homologados
            this.schema1.fields[14]['values'] = this.valoreselementos_homologados

            const listaTiposLugar = response.find(item => item.data.nombre_lista === "lugares_entrega");
            this.valoreslugar = listaTiposLugar.data.rows;
            this.schema1.fields[0]['values'] = this.valoreslugar

            const listaTiposMascara = response.find(item => item.data.nombre_lista === "tipos_mascara_oxigeno");
            this.valoresmacara = listaTiposMascara.data.rows;
            this.schema1.fields[3]['values'] = this.valoresmacara

            const listaTiposMedios = response.find(item => item.data.nombre_lista === "medios_administracion");
            this.valoresmedios = listaTiposMedios.data.rows;
            this.schema2.fields[0]['values'] = this.valoresmedios

            const listaTiposInstitu = response.find(item => item.data.nombre_lista === "instituciones");
            this.valoresinstitucion = listaTiposInstitu.data.rows;
            this.schema1.fields[5]['values'] = this.valoresinstitucion




            if (this.cliente == 1 || this.proveerdor == 1 || this.prestador == 1) {
                this.estado = this.datoseditar.estado;
                this.proveniente = "- Solicitud";
                this.vista = "Solicitud #" + this.datoseditar.id;
                this.getBinaryData(this.datoseditar.id);
                this.editable = true;

                // Modo corrección: la institución corrige una solicitud devuelta (estado 2)
                if (this.correccion && this.datoseditar.estado == 2) {
                    this.editable = false; // No es editable normal, usará botón de corregir
                    this.cliente = 0; // Desactivar modo "solo lectura" del cliente
                    this.vista = "Corregir solicitud #" + this.datoseditar.id;
                    this.proveniente = "- Corrección de solicitud devuelta";

                    // Cargar motivo de rechazo para mostrar al usuario
                    this.motivoRechazoTexto = this.datoseditar.motivo_rechazo_prestador_texto || this.datoseditar.motivo_rechazo_prestador || this.datoseditar.motivo_rechazo || '';
                    this.detalleRechazoTexto = this.datoseditar.detalle_rechazo_prestador || this.datoseditar.detalle_motivo_rechazo || '';
                    this.observacionesRechazoTexto = this.datoseditar.observaciones_rechazo_prestador || this.datoseditar.observaciones_rechazo || '';

                    console.log("=== MODO CORRECCIÓN ACTIVADO ===");
                    console.log("Motivo rechazo:", this.motivoRechazoTexto);
                    console.log("Detalle rechazo:", this.detalleRechazoTexto);
                    console.log("Observaciones rechazo:", this.observacionesRechazoTexto);
                }

                console.log("=== DEBUG CrearSolicitudes ===");
                console.log("this.proveerdor:", this.proveerdor);
                console.log("this.prestador:", this.prestador);
                console.log("this.editar:", this.editar);
                console.log("this.cliente:", this.cliente);
                console.log("this.editable:", this.editable);
                console.log("this.correccion:", this.correccion);
                console.log("Condición contenedor botones:", (this.proveerdor != 1 && this.editar != 1) || (this.prestador == 1 && this.editar == 1));
                console.log("Condición botón editar (this.editable):", this.editable);
                console.log("==============================");
                console.log("this.$route.params.myParam", this.$route.params);
                console.log("this.$route.params.myParam.nacimiento", this.$route.params.myParam.nacimiento);
                console.log("Diagnóstico recibido:", this.$route.params.myParam.diagnostico);
                console.log("Horas consumo recibido:", this.$route.params.myParam.horas_consumo_dia);
                console.log("CIE-10 recibido:", this.$route.params.myParam.cie_10_diagnostico);

                this.municipioXDepartamento(this.$route.params.myParam.departamento)
                this.model = {
                    tipo_identificacion: this.$route.params.myParam.tipo_documento,
                    identificacion: this.$route.params.myParam.documento,
                    nombre: this.$route.params.myParam.Paciente,
                    edad: (() => {
                        try {
                            const nacimiento = this.$route.params.myParam.nacimiento;
                            console.log("Procesando fecha nacimiento:", nacimiento);

                            if (!nacimiento || typeof nacimiento !== 'string') {
                                console.error("Fecha de nacimiento inválida");
                                return '';
                            }

                            let day, month, year;

                            // Procesar formato con /
                            if (nacimiento.includes('/')) {
                                const parts = nacimiento.split('/');
                                if (parts.length === 3) {
                                    const firstNum = parseInt(parts[0]);
                                    const secondNum = parseInt(parts[1]);

                                    // Detectar formato MM/DD/YYYY vs DD/MM/YYYY
                                    if (firstNum > 12) {
                                        // DD/MM/YYYY
                                        [day, month, year] = parts;
                                    } else if (secondNum > 12) {
                                        // MM/DD/YYYY
                                        [month, day, year] = parts;
                                    } else {
                                        // Formato ambiguo, asumir MM/DD/YYYY (americano)
                                        [month, day, year] = parts;
                                    }

                                    day = day.padStart(2, '0');
                                    month = month.padStart(2, '0');
                                }
                            }
                            // Procesar formato con -
                            else if (nacimiento.includes('-')) {
                                const parts = nacimiento.split('-');
                                if (parts.length === 3) {
                                    if (parts[0].length === 4) {
                                        // YYYY-MM-DD
                                        [year, month, day] = parts;
                                    } else {
                                        // DD-MM-YYYY
                                        [day, month, year] = parts;
                                    }
                                }
                            }

                            if (day && month && year) {
                                const dayNum = parseInt(day);
                                const monthNum = parseInt(month);
                                const yearNum = parseInt(year);

                                // Validar rangos
                                if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum) ||
                                    monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) {
                                    console.error("Fecha fuera de rango");
                                    return '';
                                }

                                // Formato ISO para input type="date"
                                const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                                const date = new Date(formattedDate);

                                if (isNaN(date.getTime())) {
                                    console.error("Fecha inválida después de conversión:", formattedDate);
                                    return '';
                                }

                                console.log("Fecha convertida exitosamente:", formattedDate);
                                return formattedDate;
                            }

                            console.error("No se pudo parsear la fecha");
                            return '';
                        } catch (error) {
                            console.error("Error procesando fecha:", error);
                            return '';
                        }
                    })(),
                    genero: this.$route.params.myParam.genero,
                    nacionalidad: this.$route.params.myParam.nacionalidad,
                    talla: this.$route.params.myParam.talla,
                    // edad: this.$route.params.myParam.edad,
                    departamento: this.$route.params.myParam.departamento,
                    municipio: this.$route.params.myParam.municipio,
                    // direccion: this.$route.params.myParam.direccion,
                    barrio: this.$route.params.myParam.barrio,
                    telefono1: this.$route.params.myParam.telefono_1,
                    telefono2: this.$route.params.myParam.telefono_2,
                    telefono3: this.$route.params.myParam.telefono_3,
                    cobertura: this.$route.params.myParam.cobertura,
                    afiliacion: this.$route.params.myParam.afiliacion,
                    elementos: this.$route.params.myParam.elementos,
                    elementos_institucion: this.$route.params.myParam.elementos_institucion,
                    dosis: this.$route.params.myParam.dosis,
                    lugar: this.$route.params.myParam.lugar_entrega,
                    nombreinstitucion: this.$route.params.myParam.nombre_institucion,
                    direccionequipos: this.$route.params.myParam.direccion_entrega,
                    detalleequipos: this.$route.params.myParam.detalle_entrega,
                    medioadmin: this.$route.params.myParam.medio_administracion,
                    hora: this.$route.params.myParam.hora,
                    horas: (() => {
                        // Convertir el valor de horas a número si viene como string
                        const horasValue = this.$route.params.myParam.horas_consumo_dia;
                        console.log("Procesando horas, valor recibido:", horasValue, "tipo:", typeof horasValue);

                        if (!horasValue) return null;

                        // Si es un número, retornarlo directamente
                        if (typeof horasValue === 'number') {
                            return horasValue;
                        }

                        // Si es string, intentar extraer el número
                        if (typeof horasValue === 'string') {
                            // Extraer solo los números (ej: "16 horas" -> 16)
                            const match = horasValue.match(/\d+/);
                            if (match) {
                                return parseInt(match[0]);
                            }
                        }

                        return null;
                    })(),
                    diagnostico: this.$route.params.myParam.diagnostico,
                    cie: this.$route.params.myParam.cie_10_diagnostico,
                    tiempo: this.$route.params.myParam.tiempo_revision_medica,
                    obsevacion: this.$route.params.myParam.observaciones,
                    typevia: this.$route.params.myParam.typevia,
                    number: this.$route.params.myParam.number,
                    number1: this.$route.params.myParam.number1,
                    number2: this.$route.params.myParam.number2,
                    typeinmueble: this.$route.params.myParam.typeinmueble,
                    number3: this.$route.params.myParam.number3,
                    bloque: this.$route.params.myParam.bloque,
                    number4: this.$route.params.myParam.number4,
                    eps: this.$route.params.myParam.eps,
                    namecontacto: this.$route.params.myParam.namecontacto,
                    email: this.$route.params.myParam.email,
                    obsevacionContact: this.$route.params.myParam.obsevacionContact,
                    typemascara: this.$route.params.myParam.typemascara,
                    lugarEntrega: this.$route.params.myParam.lugar_entrega,
                    nombreInstitucion: this.$route.params.myParam.nombre_institucion,
                    doctor: this.$route.params.myParam.doctor || this.$route.params.myParam.medico_tratante,
                    tipo_documento_medico: this.$route.params.myParam.tipo_documento_medico,
                    numero_documento_medico: this.$route.params.myParam.numero_documento_medico,
                    email_institucion: this.$route.params.myParam.email_institucion,
                    documento_adjunto: null,
                    tipo_paciente: this.$route.params.myParam.tipo_paciente,
                    elementos_homologacion: this.$route.params.myParam.elementos_homologacion || null,
                    elementos_institucion_homologacion: this.$route.params.myParam.elementos_institucion_homologacion || null,
                    nivel_ingreso: this.$route.params.myParam.nivel_ingreso || null,
                    ips_paciente: (this.$route.params.myParam.ips_paciente || '').toUpperCase() || null,

                };

                // Calcular la edad basándose en la fecha de nacimiento cargada
                this.calcularEdad(this.model.edad);

                // Inicializar el datalist de diagnósticos si hay un valor
                if (this.model.diagnostico) {
                    console.log("Inicializando datalist con diagnóstico:", this.model.diagnostico);
                    this.$nextTick(() => {
                        this.filterDiagnosticos(this.model.diagnostico);
                    });
                }

                // Inicializar la visibilidad de los campos de equipos según el lugar de entrega
                this.$nextTick(() => {
                    const equiposDomicilioIndex = 1;
                    const equiposInstitucionIndex = 2;
                    const homologDomicilioIndex = 13;
                    const homologInstitucionIndex = 14;

                    const hasHomologDomicilio = Array.isArray(this.model.elementos_homologacion) && this.model.elementos_homologacion.length > 0;
                    const hasHomologInstitucion = Array.isArray(this.model.elementos_institucion_homologacion) && this.model.elementos_institucion_homologacion.length > 0;
                    const esPuroProv = this.proveerdor == 1 && this.prestador != 1;

                    if (this.model.lugar == 1) { // Entrega en domicilio
                        this.schema1.fields[equiposDomicilioIndex].visible = esPuroProv ? !hasHomologDomicilio : true;
                        this.schema1.fields[equiposInstitucionIndex].visible = false;
                        this.schema1.fields[homologDomicilioIndex].visible = this.prestador == 1 ? true : (esPuroProv && hasHomologDomicilio);
                        this.schema1.fields[homologDomicilioIndex].styleClasses = 'col-md-4 offset-md-4 campo-homologacion';
                        this.schema1.fields[homologInstitucionIndex].visible = false;
                    } else if (this.model.lugar == 2) { // Entrega en institución
                        this.schema1.fields[equiposDomicilioIndex].visible = false;
                        this.schema1.fields[equiposInstitucionIndex].visible = esPuroProv ? !hasHomologInstitucion : true;
                        this.schema1.fields[homologDomicilioIndex].visible = false;
                        this.schema1.fields[homologInstitucionIndex].visible = this.prestador == 1 ? true : (esPuroProv && hasHomologInstitucion);
                        this.schema1.fields[homologInstitucionIndex].styleClasses = 'col-md-4 offset-md-8 campo-homologacion';
                    } else if (this.model.lugar == 3) { // Domicilio e Institución
                        this.schema1.fields[equiposDomicilioIndex].visible = esPuroProv ? !hasHomologDomicilio : true;
                        this.schema1.fields[equiposInstitucionIndex].visible = esPuroProv ? !hasHomologInstitucion : true;
                        this.schema1.fields[homologDomicilioIndex].visible = this.prestador == 1 ? true : (esPuroProv && hasHomologDomicilio);
                        this.schema1.fields[homologDomicilioIndex].styleClasses = 'col-md-4 offset-md-4 campo-homologacion';
                        this.schema1.fields[homologInstitucionIndex].visible = this.prestador == 1 ? true : (esPuroProv && hasHomologInstitucion);
                        this.schema1.fields[homologInstitucionIndex].styleClasses = 'col-md-4 campo-homologacion';
                    }

                    // Inicializar los valores de dosis según el tipo de paciente
                    const dosisFieldIndex = 8;
                    if (this.model.tipo_paciente === 'pediatrico') {
                        this.schema1.fields[dosisFieldIndex].values = this.valoresdosisPediatrico;
                    } else if (this.model.tipo_paciente === 'adulto') {
                        this.schema1.fields[dosisFieldIndex].values = this.valoresdosisAdulto;
                    }

                    // Inicializar opciones de nivel de ingreso según la afiliación cargada
                    if (this.model.afiliacion) {
                        const afiliacion = parseInt(this.model.afiliacion);
                        const nivelIngresoFieldIndex = 26;
                        if (afiliacion === 1 || afiliacion === 2) {
                            this.schema.fields[nivelIngresoFieldIndex].values = [
                                { id: 'Bajo', name: 'Bajo' },
                                { id: 'Medio', name: 'Medio' },
                                { id: 'Alto', name: 'Alto' },
                            ];
                        } else if (afiliacion === 3) {
                            this.schema.fields[nivelIngresoFieldIndex].values = [
                                { id: 'Nivel 1', name: 'Nivel 1' },
                                { id: 'Nivel 2', name: 'Nivel 2' },
                            ];
                        }
                    }
                });


            } else {
                this.proveniente = "- Creación de solicitudes";
                this.vista = "Creación de solicitudes";
            }


        } catch (error) {
            console.log("respuesta", error)
            if (error.response.data.mensaje == 'Token inválido') {
                localStorage.clear();
                return this.$router.push("/error401");
            }
        }

        VueFormGenerator.validators.resources.fieldIsRequired = "Campo requerido"
        VueFormGenerator.validators.resources.invalidNumber = "Campo requerido"
        VueFormGenerator.validators.resources.textTooBig = "El campo permite hasta {1} caracteres."
        VueFormGenerator.validators.resources.numberTooBig = "Excediste el limite de digítos"
        VueFormGenerator.validators.resources.invalidTextContainNumber = "¡Texto no válido! No puede contener números ni caracteres especiales"
        VueFormGenerator.validators.resources.invalidEmail = "¡Dirección de correo electrónico no válida!"
        VueFormGenerator.validators.resources.numberTooSmall = "El campo permite hasta 10 caracteres"

    },
    methods: {
        actualizarOpcionesNivelIngreso(afiliacion) {
            const nivelIngresoFieldIndex = 26;
            if (afiliacion == 1 || afiliacion == 2) { // Cotizante o Beneficiario
                this.schema.fields[nivelIngresoFieldIndex].values = [
                    { id: 'Bajo', name: 'Bajo' },
                    { id: 'Medio', name: 'Medio' },
                    { id: 'Alto', name: 'Alto' },
                ];
            } else if (afiliacion == 3) { // Subsidiado
                this.schema.fields[nivelIngresoFieldIndex].values = [
                    { id: 'Nivel 1', name: 'Nivel 1' },
                    { id: 'Nivel 2', name: 'Nivel 2' },
                ];
            } else {
                this.schema.fields[nivelIngresoFieldIndex].values = [];
            }
        },
        
        // Función para construir la dirección de forma inteligente
        construirDireccion() {
            const partes = [];
            
            // 1. Tipo de vía (obtener texto desde la lista)
            if (this.model.typevia) {
                const tipoVia = this.valorestypevia.find(v => v.id == this.model.typevia);
                if (tipoVia) {
                    partes.push(tipoVia.name);
                }
            }
            
            // 2. Números de vía (number # number1 - number2)
            const numerosVia = [];
            if (this.model.number) numerosVia.push(this.model.number);
            if (this.model.number1) {
                if (numerosVia.length > 0) {
                    numerosVia.push('#', this.model.number1);
                } else {
                    numerosVia.push(this.model.number1);
                }
            }
            if (this.model.number2) {
                if (numerosVia.length > 0) {
                    numerosVia.push('-', this.model.number2);
                } else {
                    numerosVia.push(this.model.number2);
                }
            }
            if (numerosVia.length > 0) {
                partes.push(numerosVia.join(' '));
            }
            
            // 3. Tipo de inmueble (obtener texto desde la lista)
            if (this.model.typeinmueble) {
                const tipoInmueble = this.valorestypeinmueble.find(v => v.id == this.model.typeinmueble);
                if (tipoInmueble) {
                    partes.push(tipoInmueble.name);
                }
            }
            
            // 4. Números de inmueble (number3 - bloque # number4)
            const numerosInmueble = [];
            if (this.model.number3 && this.model.number3 !== "" && this.model.number3 !== "0") {
                numerosInmueble.push('#', this.model.number3);
            }
            
            // Bloque o interior (obtener texto desde la lista)
            if (this.model.bloque && this.model.bloque !== 0 && this.model.bloque !== "0") {
                const bloqueTexto = this.valoresbloque.find(v => v.id == this.model.bloque);
                if (bloqueTexto) {
                    if (numerosInmueble.length > 0) {
                        numerosInmueble.push('-', bloqueTexto.name);
                    } else {
                        numerosInmueble.push(bloqueTexto.name);
                    }
                }
            }
            
            if (this.model.number4 && this.model.number4 !== "" && this.model.number4 !== "0") {
                if (numerosInmueble.length > 0) {
                    numerosInmueble.push('#', this.model.number4);
                } else {
                    numerosInmueble.push('#', this.model.number4);
                }
            }
            if (numerosInmueble.length > 0) {
                partes.push(numerosInmueble.join(' '));
            }
            
            // Unir todas las partes con espacio
            return partes.join(' ').trim();
        },
        
        calcularFechaValoracion(diasRevision) {
            // Si no hay días de revisión, retornar null
            if (!diasRevision || diasRevision === 0 || diasRevision === '0') {
                return null;
            }

            try {
                // Obtener la fecha actual (fecha de solicitud)
                const fechaSolicitud = new Date();

                // Convertir diasRevision a número si es string (especificar base 10)
                const dias = parseInt(diasRevision, 10);

                // Validar que sea un número válido
                if (isNaN(dias) || dias < 0) {
                    console.log("Días de revisión no válidos:", diasRevision);
                    return null;
                }

                // Calcular la fecha de valoración sumando los días
                const fechaValoracion = new Date(fechaSolicitud);
                fechaValoracion.setDate(fechaValoracion.getDate() + dias);

                // Formatear la fecha a MM/DD/YYYY para tipo DATE de base de datos
                const month = String(fechaValoracion.getMonth() + 1).padStart(2, '0');
                const day = String(fechaValoracion.getDate()).padStart(2, '0');
                const year = fechaValoracion.getFullYear();

                const fechaFormateada = `${month}/${day}/${year}`;

                console.log("Fecha de solicitud:", fechaSolicitud.toLocaleDateString());
                console.log("Días a sumar:", dias);
                console.log("Fecha de valoración calculada (MM/DD/YYYY):", fechaFormateada);

                return fechaFormateada;
            } catch (error) {
                console.error("Error al calcular fecha de valoración:", error);
                return null;
            }
        },

        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) {
                this.model.edad_calculada = null;
                return;
            }

            const hoy = new Date();
            const nacimiento = new Date(fechaNacimiento);

            if (isNaN(nacimiento.getTime())) {
                this.model.edad_calculada = null;
                return;
            }

            let edad = hoy.getFullYear() - nacimiento.getFullYear();
            const mesActual = hoy.getMonth();
            const mesNacimiento = nacimiento.getMonth();

            // Si no ha llegado el mes de cumpleaños o si es el mes pero no ha llegado el día
            if (mesActual < mesNacimiento || (mesActual === mesNacimiento && hoy.getDate() < nacimiento.getDate())) {
                edad--;
            }

            // Redondeo hacia abajo (Math.floor) para asegurar que solo muestre años completos
            this.model.edad_calculada = Math.floor(edad);
        },

        // Función para convertir fecha a formato MM/DD/YYYY para editarPaciente
        formatDateForEditPaciente(dateString) {
            if (!dateString) return '';

            console.log('formatDateForEditPaciente - Input:', dateString);

            // Si es un timestamp numérico, convertirlo a fecha
            if (typeof dateString === 'number' || !isNaN(Number(dateString))) {
                const date = new Date(Number(dateString));
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();
                const result = `${month}/${day}/${year}`;
                console.log('formatDateForEditPaciente - Output (convertido de timestamp):', result);
                return result;
            }

            // Si está en formato YYYY-MM-DD, convertir a MM/DD/YYYY
            if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
                const [year, month, day] = dateString.split('-');
                const result = `${month}/${day}/${year}`;
                console.log('formatDateForEditPaciente - Output (convertido de YYYY-MM-DD):', result);
                return result;
            }

            // Si está en formato DD/MM/YYYY, convertir a MM/DD/YYYY
            if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                const [day, month, year] = dateString.split('/');
                const result = `${month}/${day}/${year}`;
                console.log('formatDateForEditPaciente - Output (convertido de DD/MM/YYYY):', result);
                return result;
            }

            // Si ya está en formato MM/DD/YYYY, devolverlo tal como está
            if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                console.log('formatDateForEditPaciente - Output (ya en formato correcto):', dateString);
                return dateString;
            }

            console.log('formatDateForEditPaciente - Output (sin cambios):', dateString);
            return dateString;
        },

        // Función para convertir fecha YYYY-MM-DD a formato YYYY-MM-DD para base de datos (editarPaciente)
        formatDateForDatabase(dateString) {
            if (!dateString) return '';

            console.log('formatDateForDatabase - Input:', dateString);

            // Si ya está en formato YYYY-MM-DD, devolverlo tal como está
            if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
                console.log('formatDateForDatabase - Output (ya en formato correcto):', dateString);
                return dateString;
            }

            // Si está en formato DD/MM/YYYY, convertir a YYYY-MM-DD
            if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                const [day, month, year] = dateString.split('/');
                const result = `${year}-${month}-${day}`;
                console.log('formatDateForDatabase - Output (convertido):', result);
                return result;
            }

            console.log('formatDateForDatabase - Output (sin cambios):', dateString);
            return dateString;
        },

        // Función para convertir fecha YYYY-MM-DD a formato string para enviarSolicitudCliente
        formatDateForStringField(dateString) {
            if (!dateString) return '';

            console.log('formatDateForStringField - Input:', dateString);

            // Si está en formato YYYY-MM-DD, convertir a DD/MM/YYYY (formato string)
            if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
                const [year, month, day] = dateString.split('-');
                const result = `${day}/${month}/${year}`;
                console.log('formatDateForStringField - Output:', result);
                return result;
            }

            console.log('formatDateForStringField - Output (sin cambios):', dateString);
            return dateString;
        },

        // Función para convertir fecha DD/MM/YYYY a YYYY-MM-DD para creacionPaciente
        formatDateFromMDY(dateString) {
            if (!dateString) return '';

            console.log('formatDateFromMDY - Input:', dateString);

            // Si está en formato DD/MM/YYYY, convertir a YYYY-MM-DD
            if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                const [day, month, year] = dateString.split('/');
                const result = `${year}-${month}-${day}`;
                console.log('formatDateFromMDY - Output (convertido):', result);
                return result;
            }

            // Si ya está en formato YYYY-MM-DD, devolverlo tal como está
            if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
                console.log('formatDateFromMDY - Output (ya en formato correcto):', dateString);
                return dateString;
            }

            console.log('formatDateFromMDY - Output (sin cambios):', dateString);
            return dateString;
        },
        filterDiagnosticos(searchQuery) {
            if (!searchQuery || searchQuery.length < 2) {
                this.diagnosticosFiltrados = this.valorescie.slice(0, 200); // Mostrar los primeros 50 por defecto
                return;
            }

            // Filtrar los diagnósticos basándose en el texto de búsqueda
            const searchText = searchQuery.toLowerCase();
            this.diagnosticosFiltrados = this.valorescie.filter(diagnostico => {
                const codigo = diagnostico.codigo ? diagnostico.codigo.toLowerCase() : '';
                const nombre = diagnostico.name ? diagnostico.name.toLowerCase() : '';
                const id = diagnostico.id ? diagnostico.id.toString().toLowerCase() : '';
                const searchTextCombined = diagnostico.searchText ? diagnostico.searchText.toLowerCase() : '';

                return codigo.includes(searchText) ||
                    nombre.includes(searchText) ||
                    id.includes(searchText) ||
                    searchTextCombined.includes(searchText);
            }).slice(0, 200); // Limitar a 100 resultados para evitar lag
        },

        // Nuevo método para mostrar errores en modal
        mostrarError(mensaje) {
            this.mensajeError = mensaje;
            this.modalError = true;
            this.load = false; // Detener el spinner de carga
        },

        // Método para cerrar el modal de error
        cerrarModalError() {
            this.modalError = false;
            this.mensajeError = "";
        },
        async getBinaryData(id) {
            var data = {

                "nombre_entidad": "archivos",
                "nombre_entidad_archivo": "creacion_solicitud",
                "id_entidad": id

            }
            const response = await clientes.ConsultarArchivosentidadId(data);
            this.cantidadImg = response;
            console.log("response", response);

            return response;
        },
        convertBinaryToImage(binaryData, typefile) {
            let mimeType;

            // Verificar el tipo de archivo y asignar el mimeType correspondiente
            if (typefile === '.png' || typefile === '.jpg' || typefile === '.jpeg') {
                mimeType = typefile === '.png' ? 'image/png' : 'image/jpeg';
            } else if (typefile === '.pdf') {
                mimeType = 'application/pdf';  // Tipo MIME para PDF
            } else {
                mimeType = 'application/octet-stream';  // Para otros tipos desconocidos
            }

            // Crear un Blob desde los datos binarios
            const blob = new Blob([new Uint8Array(binaryData)], { type: mimeType });

            // Crear y retornar una URL temporal para el Blob
            const url = URL.createObjectURL(blob);

            return url;
        },
        openImage(url) {
            console.log(url);

            // Si el archivo está en Azure Storage, abrir directamente la URL temporal
            if (url.is_azure && url.temp_url) {
                window.open(url.temp_url, '_blank');
                return;
            }

            // Si no está en Azure o no hay temp_url, usar el método tradicional con datos binarios
            if (url.data && url.data.data) {
                const imageUrls = this.convertBinaryToImage(url.data.data, url.typefile);
                // Asignar las URLs a la propiedad `imageUrls`
                this.imageUrls = imageUrls;
                window.open(this.imageUrls, '_blank');
            } else {
                console.error('No se puede abrir el archivo: no hay datos disponibles');
            }
        },
        showAlert(message) {
            this.alertText = message;
            this.alertA = true;
            if (this.documento_adjunto.length > 0) {
                this.alertA = false;
            }
        },
        showNotification(message) {
            this.notificationMessage = message;
            this.showNotificationFlag = true;

            // Ocultar la notificación después de 3 segundos
            setTimeout(() => {
                this.showNotificationFlag = false;
            }, 3000);
        },
        async handleInputChange(event) {
            this.buscandoPaciente = true;
            console.log("esteeee--->", event);
            var where = [{
                "AND": [
                    {
                        "id": {
                            "notEquals": ""
                        }
                    },
                    {
                        "numero_de_identificacion": {
                            "equals": event
                        }
                    }

                ]
            }];
            var params = {

                "nombreEntidad": "entidad_paciente",
                "idVersion": 5,
                "column": "id",
                "type": "desc",
                "size": 100000,
                "page": 1,
            }
            var relaciones = [];
            let responsep;
            try {
                responsep = await config.getMetaData(params, where, relaciones);
            } catch (e) {
                this.buscandoPaciente = false;
                return;
            }
            // La API puede devolver 200 HTTP pero con status 400 en el body (paciente no encontrado)
            if (!responsep || responsep.status !== 200 || !responsep.message || !responsep.message.rows) {
                this.buscandoPaciente = false;
                return;
            }
            const selectedValue = event;
            console.log("row->", responsep.message.rows);
            console.log("selectedValue->", selectedValue);

            var empty = responsep.message.rows.find(size => {
                console.log("numero_de_identificacion", size.data.numero_de_identificacion)
                return size.data.numero_de_identificacion == selectedValue
            });
            this.sizes = responsep.message.rows.map((x) => {

                var dataa = {
                    'afiliacion': parseInt(x.data.afiliacion) ?? '',
                    'barrio': x.data.barrio ?? '',
                    'cobertura': parseInt(x.data.cobertura) ?? '',
                    'createat': x.data.createat ?? '',
                    'departamento': x.data.departamento ?? '',
                    'idpaciente': parseInt(x.data.id) ?? '',
                    'idModulo': x.data.idModulo ?? '',
                    'idTenant': x.data.idTenant ?? '',
                    'idUsuario': x.data.idUsuario ?? '',
                    'idVersion': x.data.idVersion ?? '',
                    'municipio': x.data.municipio ?? '',
                    'nombre': x.data.nombre_completo ?? '',
                    'identificacion': x.data.numero_de_identificacion ?? '',
                    'telefono1': x.data.telefono_1 ?? '',
                    'telefono2': x.data.telefono_2 ?? '',
                    'telefono3': x.data.telefono_3 ?? '',
                    'tipo_identificacion': parseInt(x.data.tipo_de_identificacion) ?? '',
                    'updateat': x.data.updateat ?? '',
                    edad: x.data.nacimiento
                        ? (() => {
                            const [day, month, year] = x.data.nacimiento.split('/');
                            const formattedDate = `${day}-${month}-${year}`;
                            const date = new Date(formattedDate);
                            return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
                        })()
                        : '',
                    'genero': x.data.genero ?? '',
                    'nacionalidad': x.data.nacionalidad ?? '',
                    'talla': x.data.talla ?? '',
                    'typevia': x.data.tipo_via ?? '',
                    'number': x.data.number ?? '',
                    'number1': x.data.number1 ?? '',
                    'number2': x.data.number2 ?? '',
                    'typeinmueble': x.data.tipo_inmueble ?? '',
                    'number3': x.data.number3 ?? 0,
                    'bloque': x.data.bloque ?? 0,
                    'number4': x.data.number4 ?? 0,
                    'eps': x.data.eps ?? '',
                    'namecontacto': x.data.nombre_contacto ?? '',
                    'email': x.data.email ?? '',
                    'obsevacionContact': x.data.observacion_contacto ?? '',

                };

                console.log("esto es data--------->", dataa)
                return dataa;
            });
            console.log("respuesta", empty)

            if (!empty) {
                this.buscandoPaciente = false;
                return;
            }
            console.log("this.size---model", this.sizes);
            this.model = this.sizes.find(size => size.identificacion === selectedValue);

            console.log("departamento---model", this.model.departamento);
            this.municipioXDepartamento(this.model.departamento)
            console.log("pasooooooooooooooooooooooooooooooo---model", this.model);
            this.idpaciente = this.model.idpaciente;
            console.log("paciente", this.idpaciente)
            this.buscandoPaciente = false;
        },
        back() {
            this.$router.go(-1)
        },
        disissDownChanged(disiss) {
            this.disiss = disiss
        },
        async creacionPaciente() {
            try {
                const response = await clientes.Guardarentidadpaciente({
                    nombre_entidad: "entidad_paciente",
                    id_version: 1,
                    tipo_documento: this.model.tipo_identificacion,
                    documento: this.model.identificacion,
                    nombre_completo: this.model.nombre,
                    departamento: this.model.departamento,
                    direccion: this.construirDireccion(),
                    municipio: this.model.municipio,
                    barrio: this.model.barrio,
                    telefono_1: this.model.telefono1,
                    telefono_2: this.model.telefono2,
                    telefono_3: this.model.telefono3,
                    cobertura: this.model.cobertura,
                    afiliacion: this.model.afiliacion,
                    nacimiento: this.model.edad ? this.formatDateForEditPaciente(this.model.edad) :
                        (this.model.fechaConvertida ? this.formatDateFromMDY(this.model.fechaConvertida) : ''),
                    genero: this.model.genero,
                    nacionalidad: this.model.nacionalidad,
                    talla: (this.model.talla && this.model.talla !== "") ? this.model.talla : 0,
                    tipo_via: (this.model.typevia && this.model.typevia !== "") ? this.model.typevia : 0,
                    number: (this.model.number && this.model.number !== "") ? this.model.number : "",
                    number1: (this.model.number1 && this.model.number1 !== "") ? this.model.number1 : "",
                    number2: (this.model.number2 && this.model.number2 !== "") ? this.model.number2 : "",
                    tipo_inmueble: (this.model.typeinmueble && this.model.typeinmueble !== "") ? this.model.typeinmueble : 0,
                    number3: this.model.number3.toString(),
                    bloque: this.model.bloque,
                    number4: this.model.number4.toString(),
                    eps: this.model.eps,
                    nombre_contacto: this.model.namecontacto,
                    email: this.model.email,
                    observacion_contacto: this.model.obsevacionContact,

                });
                this.idpaciente = response.id;
            } catch (error) {
                this.disiss = this.dis;
                this.mensajeerror = error.response.data.error.message;
            }
        },
        async editarPaciente() {
            try {
                console.log("=== DEBUG editarPaciente ===");
                console.log("this.model.edad:", this.model.edad);
                console.log("this.model.edad:", this.model.nacimiento);
                console.log("this.model.fechaConvertida:", this.model.fechaConvertida);

                // const fechaNacimiento = (this.model.nacimiento ? this.formatDateForEditPaciente(this.model.nacimiento) : 
                //            this.model.fechaConvertida ? this.formatDateForEditPaciente(this.model.fechaConvertida) : '');

                console.log("fechaNacimiento final para API (MM/DD/YYYY):", fechaNacimiento);
                console.log("paso editar--------<");

                const response = await clientes.editarentidadpaciente({
                    nombre_entidad: "entidad_paciente",
                    id_version: 1,
                    id_metadata: this.idpaciente,
                    tipo_documento: this.model.tipo_identificacion,
                    documento: this.model.identificacion,
                    nombre_completo: this.model.nombre,
                    departamento: this.model.departamento,
                    direccion: this.construirDireccion(),
                    municipio: this.model.municipio,
                    barrio: this.model.barrio,
                    telefono_1: this.model.telefono1,
                    telefono_2: this.model.telefono2,
                    telefono_3: this.model.telefono3,
                    cobertura: this.model.cobertura,
                    afiliacion: this.model.afiliacion,
                    nacimiento: this.model.nacimiento,
                    genero: this.model.genero,
                    nacionalidad: this.model.nacionalidad,
                    talla: this.model.talla,
                    tipo_via: this.model.typevia,
                    number: this.model.number,
                    number1: this.model.number1,
                    number2: this.model.number2,
                    tipo_inmueble: (this.model.typeinmueble && this.model.typeinmueble !== "") ? this.model.typeinmueble : 0,
                    number3: this.model.number3.toString(),
                    bloque: this.model.bloque,
                    number4: this.model.number4.toString(),
                    eps: this.model.eps,
                    nombre_contacto: this.model.namecontacto,
                    email: this.model.email,
                    observacion_contacto: this.model.obsevacionContact,

                });
                console.log("response", response);
                this.idpaciente = response.id;

            } catch (error) {

            }

        },
        async enviarSolicitudCliente() {
            console.log("Paciente ID:", this.idpaciente);

            // Verificar si es edición o creación
            if (this.idpaciente != null) {
                console.log("Modo de edición activado");
                this.editarPaciente();
            } else {
                console.log("Modo de creación activado");
                this.creacionPaciente();
            }

            // Validación de formularios
            this.estado = 1;
            const isValidForm = this.$refs.newMemberForm.validate() &&
                this.$refs.newMemberForm1.validate() &&
                this.$refs.newMemberForm2.validate() &&
                this.$refs.newMemberForm3.validate();

            if (isValidForm) {
                this.load = true;

                try {
                    // Asignar valor predeterminado si el campo está vacío
                    if (this.model.nombreinstitucion == null) {
                        this.model.nombreinstitucion = 0;
                    }

                    console.log("Guardando datos del paciente:", this.model);
                    console.log("Guardando datos del paciente:", this.model.edad);
                    const datosUser = localStorage.getItem('user');
                    let datoUserJSON = JSON.parse(datosUser);
                    let dato_cliente = datoUserJSON.id_cliente;

                    // Si estamos editando (hay datoseditar), usar el id_cliente original
                    if (this.datoseditar && this.datoseditar.id_cliente) {
                        dato_cliente = this.datoseditar.id_cliente;
                        console.log("Modo edición: usando id_cliente original:", dato_cliente);
                    } else {
                        console.log("Modo creación: usando id_cliente del usuario actual:", dato_cliente);
                    }

                    console.log("datoUserJSON", datoUserJSON, "id Cliente >>", dato_cliente);

                    // Solicitud para guardar la entidad del paciente
                    const response = await clientes.Guardarentidad({
                        nombre_entidad: this.entidad,
                        id_version: this.version,
                        tipo_documento: this.model.tipo_identificacion,
                        documento: this.model.identificacion,
                        nombre_completo: this.model.nombre,
                        departamento: this.model.departamento,
                        municipio: this.model.municipio,
                        direccion: this.construirDireccion(),
                        barrio: this.model.barrio,
                        telefono_1: this.model.telefono1,
                        telefono_2: this.model.telefono2,
                        telefono_3: this.model.telefono3,
                        cobertura: this.model.cobertura,
                        afiliacion: this.model.afiliacion,
                        elementos: this.model.elementos,
                        elementos_institucion: this.model.elementos_institucion,
                        dosis: this.model.dosis.toString(),
                        hora_dosis: this.model.hora,
                        lugar_entrega: this.model.lugar,
                        nombre_institucion: this.model.nombreinstitucion,
                        direccion_entrega: this.model.direccionequipos,
                        detalle_entrega: this.model.detalleequipos,
                        medio_administracion: this.model.medioadmin,
                        horas_consumo_dia: this.model.horas.toString(),
                        diagnostico: this.model.diagnostico,
                        cie_10_diagnostico: this.model.cie,
                        tiempo_revision_medica: parseInt(this.model.tiempo),
                        estado: this.estado,
                        observacion: this.model.obsevacion,
                        id_cliente: dato_cliente,
                        fecha_valoracion: this.calcularFechaValoracion(this.model.tiempo),
                        id_proveedor: 0,
                        id_paciente: this.idpaciente ?? 0,

                        // nacimiento: this.idsolicitud && this.model.edad ? this.formatDateForStringField(this.model.edad) : (this.model.fechaConvertida || ''),
                        nacimiento: this.model.edad ? this.formatDateForEditPaciente(this.model.edad) :
                            (this.model.fechaConvertida ? this.formatDateFromMDY(this.model.fechaConvertida) : ''),
                        genero: this.model.genero,
                        nacionalidad: this.model.nacionalidad,
                        talla: (this.model.talla && this.model.talla !== "") ? this.model.talla : 0,
                        tipo_via: (this.model.typevia && this.model.typevia !== "") ? this.model.typevia : 0,
                        number: this.model.number,
                        number1: this.model.number1,
                        number2: this.model.number2,
                        tipo_inmueble: this.model.typeinmueble,
                        number3: this.model.number3.toString(),
                        bloque: this.model.bloque,
                        number4: this.model.number4.toString(),
                        eps: this.model.eps,
                        nombre_contacto: this.model.namecontacto,
                        email: this.model.email,
                        observacion_contacto: this.model.obsevacionContact,
                        //tipo_mascara: this.model.typemascara,
                        tipo_mascara: 0,
                        // lugarEntrega: this.model.lugarEntrega,
                        // nombreInstitucion: this.model.nombreInstitucion,
                        doctor: this.model.doctor,
                        tipo_documento_medico: this.model.tipo_documento_medico,
                        numero_documento_medico: this.model.numero_documento_medico,
                        email_institucion: this.model.email_institucion,
                        //documento_adjunto: this.model.documento_adjunto
                        tipo_paciente: this.model.tipo_paciente,
                        nivel_ingreso: this.model.nivel_ingreso || '',
                        ips_paciente: this.model.ips_paciente || '',

                    });

                    this.idsolicitud = response.id;

                    // Determinar la ruta de redirección basada en el tipo de usuario
                    if (this.prestador == 1) {
                        this.ruta = "/prestador-recepcion-solicitudes";
                        console.log("Prestador detectado - Redirigiendo a:", this.ruta);
                    } else if (this.proveerdor == 1) {
                        this.ruta = "/proveedor-solicitudes";
                        console.log("Proveedor detectado - Redirigiendo a:", this.ruta);
                    } else {
                        this.ruta = "/mis-solicitudes";
                        console.log("Cliente detectado - Redirigiendo a:", this.ruta);
                    }

                    this.mensaje = `Su solicitud ha sido creada exitosamente. Número de solicitud: ${this.idsolicitud}`;
                    this.bloqueo = true;
                    this.gurardarArchivo(response.id);

                } catch (error) {
                    console.log("Error completo:", error);

                    // Manejo específico de errores del API
                    if (error.response && error.response.data) {
                        if (error.response.data.mensaje === 'Token inválido') {
                            localStorage.clear();
                            return this.$router.push("/error401");
                        }

                        const errorMessage = error.response.data.error?.message ||
                            error.response.data.mensaje ||
                            "Error desconocido en el servidor";

                        this.mostrarError(errorMessage);
                    } else if (error.request) {
                        this.mostrarError("No se pudo conectar con el servidor. Verifique su conexión a internet.");
                    } else {
                        this.mostrarError("Ocurrió un error inesperado. Intente nuevamente.");
                    }
                }
            } else {
                // Mensaje de error de validación
                this.disiss = this.dis;
                this.mensajeerror = "Campos inválidos o sin llenar cuando son obligatorios";
            }
        },
        async gurardarArchivo(id) {
            try {
                // Verificar que el archivo exista y tenga al menos un elemento válido
                if (!this.archivoAdjunto || this.archivoAdjunto.length === 0) {
                    console.error("No se ha seleccionado ningún archivo para enviar.");
                    return;
                }
                const archivosValidos = this.archivoAdjunto.filter(f => f instanceof File);
                if (archivosValidos.length === 0) {
                    console.error("Los archivos seleccionados no son válidos.");
                    return;
                }

                // Crear la estructura
                const estructura = {
                    "nombre_entidad": "creacion_solicitud",
                    "id_entidad": id,
                };

                // Crear el objeto `FormData` para enviar el archivo como `Blob`
                const formData = new FormData();
                formData.append('nombre_entidad', 'archivos'); // Datos adicionales
                formData.append('estructura', JSON.stringify(estructura)); // Serializar estructura
                // Agregar solo los archivos que existan y sean instancias de File
                archivosValidos.forEach(archivo => {
                    formData.append('entidad', archivo);
                });

                // Enviar la solicitud al servidor
                const response1 = await clientes.GuardarArchivosentidad(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Tipo de contenido para archivos
                    },
                });

                console.log("Archivo enviado con éxito:", response1);
            } catch (error) {
                console.error("Error al enviar el archivo:", error.message || error);
            }

        },
        async corregirSolicitud() {
            // Confirmar con el usuario
            const confirmado = await this.$bvModal.msgBoxConfirm(
                '¿Está seguro de que desea corregir y reenviar esta solicitud? Se cambiará el estado a "Nuevo" para que el prestador la revise de nuevo.',
                {
                    title: 'Confirmar corrección',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'warning',
                    okTitle: 'Sí, corregir y reenviar',
                    cancelTitle: 'Cancelar',
                    centered: true,
                    headerBgVariant: 'warning',
                    headerTextVariant: 'dark'
                }
            );

            if (!confirmado) return;

            // Cambiar estado a 1 (Nuevo) para que el prestador la revise de nuevo
            this.estado = 1;

            // Usar la misma lógica de editar
            var error = this.$refs.newMemberForm.validate();
            var error2 = this.$refs.newMemberForm2.validate();
            var error3 = this.$refs.newMemberForm3.validate();
            if (error == true && error2 == true && error3 == true) {
                this.load = true;
                try {
                    const response = await clientes.editarentidadsolicitud({
                        "nombre_entidad": "entidad_solicitud",
                        "id_version": "2",
                        "id_metadata": this.datoseditar.id,
                        "tipo_documento": parseInt(this.model.tipo_identificacion),
                        "documento": parseInt(this.model.identificacion),
                        "nombre_completo": this.model.nombre,
                        "departamento": this.model.departamento,
                        "municipio": this.model.municipio,
                        "direccion": this.construirDireccion(),
                        nacimiento: this.model.edad ? this.formatDateForEditPaciente(this.model.edad) :
                            (this.model.fechaConvertida ? this.formatDateFromMDY(this.model.fechaConvertida) : ''),
                        hora_dosis: this.model.hora,
                        genero: this.model.genero,
                        nacionalidad: this.model.nacionalidad,
                        talla: this.model.talla,
                        tipo_via: this.model.typevia,
                        number: this.model.number,
                        number1: this.model.number1,
                        number2: this.model.number2,
                        tipo_inmueble: this.model.typeinmueble,
                        number3: this.model.number3.toString(),
                        bloque: this.model.bloque,
                        number4: this.model.number4.toString(),
                        eps: this.model.eps,
                        nombre_contacto: this.model.namecontacto,
                        email: this.model.email,
                        observacion_contacto: this.model.obsevacionContact,
                        "barrio": this.model.barrio,
                        "telefono_1": parseInt(this.model.telefono1),
                        "telefono_2": parseInt(this.model.telefono2),
                        "telefono_3": parseInt(this.model.telefono3),
                        "cobertura": parseInt(this.model.cobertura),
                        "afiliacion": parseInt(this.model.afiliacion),
                        "elementos": Array.from(this.model.elementos || []),
                        "elementos_institucion": Array.from(this.model.elementos_institucion || []),
                        "dosis": this.model.dosis ? this.model.dosis.toString() : '',
                        "lugar_entrega": parseInt(this.model.lugar),
                        "nombre_institucion": this.model.nombreinstitucion,
                        "direccion_entrega": this.model.direccionequipos,
                        "detalle_entrega": this.model.detalleequipos,
                        "medio_administracion": Array.from(this.model.medioadmin || []),
                        "horas_consumo_dia": this.model.horas.toString(),
                        "diagnostico": this.model.diagnostico,
                        "cie_10_diagnostico": this.model.cie,
                        "tiempo_revision_medica": parseInt(this.model.tiempo),
                        "observacion": this.model.obsevacion,
                        "estado": 1, // Estado Nuevo - para reenvío
                        "id_cliente": this.datoseditar.id_cliente,
                        "fecha_valoracion": this.calcularFechaValoracion(this.model.tiempo),
                        "id_proveedor": this.datoseditar.id_proveedor,
                        "tipo_documento_medico": this.model.tipo_documento_medico,
                        "numero_documento_medico": this.model.numero_documento_medico,
                        "email_institucion": this.model.email_institucion,
                        "doctor": this.model.doctor,
                        "tipo_paciente": this.model.tipo_paciente,
                        "elementos_homologacion": Array.from(this.model.elementos_homologacion || []),
                        "elementos_institucion_homologacion": Array.from(this.model.elementos_institucion_homologacion || []),
                        "nivel_ingreso": this.model.nivel_ingreso || null,
                        "ips_paciente": this.model.ips_paciente || null,
                    });

                    this.ruta = "/mis-solicitudes";
                    this.mensaje = "Su solicitud ha sido corregida y reenviada exitosamente. El prestador la revisará de nuevo.";
                    // Adjuntar nuevos archivos si el usuario seleccionó alguno
                    if (this.archivoAdjunto && this.archivoAdjunto.length > 0) {
                        await this.gurardarArchivo(this.datoseditar.id);
                        await this.getBinaryData(this.datoseditar.id);
                    }
                    this.bloqueo = true;
                } catch (error) {
                    console.error("Error al corregir solicitud:", error);

                    if (error.response && error.response.data) {
                        if (error.response.data.mensaje == 'Token inválido') {
                            localStorage.clear();
                            return this.$router.push("/error401");
                        }

                        const errorMessage = error.response.data.error?.message ||
                            error.response.data.mensaje ||
                            "Error desconocido en el servidor";

                        this.mostrarError(errorMessage);
                    } else if (error.request) {
                        this.mostrarError("No se pudo conectar con el servidor. Verifique su conexión a internet.");
                    } else {
                        this.mostrarError("Ocurrió un error inesperado. Intente nuevamente.");
                    }
                }
                this.load = false;
            } else {
                this.disiss = this.dis;
                this.mensajeerror = "Campos inválidos o sin llenar cuando son obligatorios";
            }
        },
        async editarSolicitudCliente() {
            var error = this.$refs.newMemberForm.validate();
            // var error1 =this.$refs.newMemberForm1.validate();
            var error2 = this.$refs.newMemberForm2.validate();
            var error3 = this.$refs.newMemberForm3.validate();
            if (error == true && error2 == true && error3 == true) {
                this.load = true;
                try {


                    console.log("Guardando datos del paciente para edición:", this.model.dosis);
                    const response = await clientes.editarentidadsolicitud({
                        "nombre_entidad": "entidad_solicitud",
                        "id_version": "2",
                        "id_metadata": this.datoseditar.id,
                        "tipo_documento": parseInt(this.model.tipo_identificacion),
                        "documento": parseInt(this.model.identificacion),
                        "nombre_completo": this.model.nombre,
                        "departamento": this.model.departamento,
                        "municipio": this.model.municipio,
                        "direccion": this.construirDireccion(),
                        nacimiento: this.model.edad ? this.formatDateForEditPaciente(this.model.edad) :
                            (this.model.fechaConvertida ? this.formatDateFromMDY(this.model.fechaConvertida) : ''),
                        hora_dosis: this.model.hora,
                        genero: this.model.genero,
                        nacionalidad: this.model.nacionalidad,
                        talla: this.model.talla,
                        tipo_via: this.model.typevia,
                        number: this.model.number,
                        number1: this.model.number1,
                        number2: this.model.number2,
                        tipo_inmueble: this.model.typeinmueble,
                        number3: this.model.number3 != null ? this.model.number3.toString() : '',
                        bloque: this.model.bloque,
                        number4: this.model.number4 != null ? this.model.number4.toString() : '',
                        eps: this.model.eps,
                        nombre_contacto: this.model.namecontacto,
                        email: this.model.email,
                        observacion_contacto: this.model.obsevacionContact,
                        "barrio": this.model.barrio,
                        "telefono_1": parseInt(this.model.telefono1),
                        "telefono_2": parseInt(this.model.telefono2),
                        "telefono_3": parseInt(this.model.telefono3),
                        "cobertura": parseInt(this.model.cobertura),
                        "afiliacion": parseInt(this.model.afiliacion),
                        "elementos": Array.from(this.model.elementos || []),
                        "elementos_institucion": Array.from(this.model.elementos_institucion || []),
                        "dosis": this.model.dosis ? this.model.dosis.toString() : '',
                        "lugar_entrega": parseInt(this.model.lugar),
                        "nombre_institucion": this.model.nombreinstitucion,
                        "direccion_entrega": this.model.direccionequipos,
                        "detalle_entrega": this.model.detalleequipos,
                        "medio_administracion": Array.from(this.model.medioadmin || []),
                        "horas_consumo_dia": this.model.horas.toString(),
                        "diagnostico": this.model.diagnostico,
                        "cie_10_diagnostico": this.model.cie,
                        "tiempo_revision_medica": parseInt(this.model.tiempo),
                        "observacion": this.model.obsevacion,
                        "estado": this.estado,
                        "id_cliente": this.datoseditar.id_cliente,
                        "fecha_valoracion": this.calcularFechaValoracion(this.model.tiempo),
                        "id_proveedor": this.datoseditar.id_proveedor,
                        "tipo_documento_medico": this.model.tipo_documento_medico,
                        "numero_documento_medico": this.model.numero_documento_medico,
                        "email_institucion": this.model.email_institucion,
                        "doctor": this.model.doctor,
                        "tipo_paciente": this.model.tipo_paciente,
                        "elementos_homologacion": Array.from(this.model.elementos_homologacion || []),
                        "elementos_institucion_homologacion": Array.from(this.model.elementos_institucion_homologacion || []),
                        "nivel_ingreso": this.model.nivel_ingreso || null,
                        "ips_paciente": this.model.ips_paciente || null,

                    });

                    // Determinar la ruta de redirección basada en el tipo de usuario
                    if (this.prestador == 1) {
                        this.ruta = "/prestador-recepcion-solicitudes";
                        console.log("Prestador detectado - Redirigiendo a:", this.ruta);
                    } else if (this.proveerdor == 1) {
                        this.ruta = "/proveedor-solicitudes"; // O la ruta que corresponda para proveedores
                        console.log("Proveedor detectado - Redirigiendo a:", this.ruta);
                    } else {
                        this.ruta = "/mis-solicitudes"; // Ruta por defecto para clientes
                        console.log("Cliente detectado - Redirigiendo a:", this.ruta);
                    }

                    this.mensaje = "Su solicitud ha sido editada exitosamente.";
                    // Adjuntar nuevos archivos si el usuario seleccionó alguno
                    if (this.archivoAdjunto && this.archivoAdjunto.length > 0) {
                        await this.gurardarArchivo(this.datoseditar.id);
                        await this.getBinaryData(this.datoseditar.id);
                    }
                    this.bloqueo = true;
                } catch (error) {
                    console.log("Error completo:", error);

                    // Manejo específico de errores del API
                    if (error.response && error.response.data) {
                        if (error.response.data.mensaje == 'Token inválido') {
                            localStorage.clear();
                            return this.$router.push("/error401");
                        }

                        // Mostrar error específico del API en modal
                        const errorMessage = error.response.data.error?.message ||
                            error.response.data.mensaje ||
                            "Error desconocido en el servidor";

                        this.mostrarError(errorMessage);
                    } else if (error.request) {
                        // Error de red
                        this.mostrarError("No se pudo conectar con el servidor. Verifique su conexión a internet.");
                    } else {
                        // Otros errores
                        this.mostrarError("Ocurrió un error inesperado. Intente nuevamente.");
                    }
                }
            } else {
                this.disiss = this.dis;
                this.mensajeerror = "Campos inválidos o sin llenar cuando son obligatorios"
            }
        },
        async municipioXDepartamento(codeDepartment) {
            var municipios = this.valoresdepartamentos.filter(x => x.codigo_departamento == codeDepartment).map(x => {
                return {
                    id: x.codigo_municipio,
                    name: x.nombre_municipio
                }
            })
            this.schema.fields[8]['values'] = municipios
        },

        // Función para exportar los datos del detalle de solicitud a Excel
        exportarAExcel() {
            try {
                // Importar XLSX si no está disponible
                if (typeof XLSX === 'undefined') {
                    console.error('La librería XLSX no está disponible');
                    this.$bvToast.toast('Error al exportar: librería no disponible', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }

                // Preparar los datos escaneando dinámicamente todos los campos
                const datosCompletos = [];

                // SECCIÓN PACIENTE
                datosCompletos.push({ 'Campo': '=== PACIENTE ===', 'Valor': '' });
                this.schema.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        datosCompletos.push({
                            'Campo': field.label || field.model,
                            'Valor': valor
                        });
                    }
                });

                // Fila vacía
                datosCompletos.push({ 'Campo': '', 'Valor': '' });

                // SECCIÓN EQUIPOS
                datosCompletos.push({ 'Campo': '=== EQUIPOS ===', 'Valor': '' });
                this.schema1.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        datosCompletos.push({
                            'Campo': field.label || field.model,
                            'Valor': valor
                        });
                    }
                });

                // Fila vacía
                datosCompletos.push({ 'Campo': '', 'Valor': '' });

                // SECCIÓN MEDIO DE ADMINISTRACIÓN
                datosCompletos.push({ 'Campo': '=== MEDIO DE ADMINISTRACIÓN ===', 'Valor': '' });
                this.schema2.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        datosCompletos.push({
                            'Campo': field.label || field.model,
                            'Valor': valor
                        });
                    }
                });

                // Fila vacía
                datosCompletos.push({ 'Campo': '', 'Valor': '' });

                // SECCIÓN DIAGNÓSTICO
                datosCompletos.push({ 'Campo': '=== DIAGNÓSTICO ===', 'Valor': '' });
                this.schema3.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        datosCompletos.push({
                            'Campo': field.label || field.model,
                            'Valor': valor
                        });
                    }
                });

                // Crear el libro de trabajo
                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(datosCompletos);

                // Ajustar el ancho de las columnas
                ws['!cols'] = [
                    { wch: 40 },  // Campo
                    { wch: 60 }   // Valor
                ];

                // Agregar la hoja al libro
                XLSX.utils.book_append_sheet(wb, ws, 'Detalle Solicitud');

                // Generar el nombre del archivo
                const nombreArchivo = `Solicitud_${this.model.identificacion || 'detalle'}_${new Date().getTime()}.xlsx`;

                // Descargar el archivo
                XLSX.writeFile(wb, nombreArchivo);

                this.$bvToast.toast('Archivo Excel descargado exitosamente', {
                    title: 'Éxito',
                    variant: 'success',
                    solid: true
                });
            } catch (error) {
                console.error('Error al exportar a Excel:', error);
                this.$bvToast.toast('Error al exportar los datos', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            }
        },

        // Función para copiar los datos del detalle de solicitud al portapapeles
        async copiarAlPortapapeles() {
            try {
                let textoCompleto = '=== DETALLE DE SOLICITUD ===\n\n';

                // SECCIÓN PACIENTE
                textoCompleto += '--- PACIENTE ---\n';
                this.schema.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        textoCompleto += `${field.label || field.model}: ${valor}\n`;
                    }
                });
                textoCompleto += '\n';

                // SECCIÓN EQUIPOS
                textoCompleto += '--- EQUIPOS ---\n';
                this.schema1.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        textoCompleto += `${field.label || field.model}: ${valor}\n`;
                    }
                });
                textoCompleto += '\n';

                // SECCIÓN MEDIO DE ADMINISTRACIÓN
                textoCompleto += '--- MEDIO DE ADMINISTRACIÓN ---\n';
                this.schema2.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        textoCompleto += `${field.label || field.model}: ${valor}\n`;
                    }
                });
                textoCompleto += '\n';

                // SECCIÓN DIAGNÓSTICO
                textoCompleto += '--- DIAGNÓSTICO ---\n';
                this.schema3.fields.forEach(field => {
                    if (field.visible === false) return; // Saltar campos no visibles

                    const valor = this.obtenerValorCampo(field, this.model[field.model]);
                    if (valor !== null && valor !== undefined && valor !== '') {
                        textoCompleto += `${field.label || field.model}: ${valor}\n`;
                    }
                });

                // Copiar al portapapeles
                await navigator.clipboard.writeText(textoCompleto);

                // Mostrar alerta de éxito
                this.mostrarAlertaCopia = true;

                // Ocultar la alerta después de 3 segundos
                setTimeout(() => {
                    this.mostrarAlertaCopia = false;
                }, 3000);

            } catch (error) {
                console.error('Error al copiar al portapapeles:', error);
                this.$bvToast.toast('Error al copiar los datos', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            }
        },

        // Función auxiliar para obtener el valor correcto de un campo según su tipo
        obtenerValorCampo(field, valorActual) {
            if (!field || valorActual === null || valorActual === undefined || valorActual === '') {
                return '';
            }

            // Para campos tipo select, buscar el texto correspondiente
            if (field.type === 'select' && field.values && Array.isArray(field.values)) {
                const item = field.values.find(v => {
                    // Comparar tanto como número como string
                    return v.id == valorActual || String(v.id) === String(valorActual);
                });

                if (item) {
                    // Buscar en orden: name, nombre_municipio, nombre_departamento
                    return item.name || item.nombre_municipio || item.nombre_departamento || valorActual;
                }
            }

            // Para campos tipo checklist (múltiple selección)
            if (field.type === 'checklist' && field.values && Array.isArray(field.values) && Array.isArray(valorActual)) {
                const nombres = valorActual.map(id => {
                    const item = field.values.find(v => v.id == id || String(v.id) === String(id));
                    return item ? (item.name || item.nombre || id) : id;
                }).filter(Boolean);

                return nombres.length > 0 ? nombres.join(', ') : '';
            }

            // Para campos de fecha
            if (field.type === 'input' && field.inputType === 'date' && valorActual) {
                // Si es una fecha ISO, formatearla
                if (typeof valorActual === 'string' && valorActual.includes('-')) {
                    try {
                        const fecha = new Date(valorActual);
                        if (!isNaN(fecha.getTime())) {
                            const dia = String(fecha.getDate()).padStart(2, '0');
                            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
                            const anio = fecha.getFullYear();
                            return `${dia}/${mes}/${anio}`;
                        }
                    } catch (e) {
                        return valorActual;
                    }
                }
                return valorActual;
            }

            // Para campos numéricos, convertir a string
            if (field.type === 'input' && field.inputType === 'number') {
                return String(valorActual);
            }

            // Para el resto de campos, retornar el valor directamente
            return String(valorActual);
        }
    },
    mounted() {
        var elementosInfo = document.querySelectorAll('.info');
        // Itera sobre cada elemento y ajusta el contenido
        elementosInfo.forEach(function (elemento) {
            // Obtén el contenido actual del elemento
            var contenidoActual = elemento.textContent || elemento.innerText;

            // Reemplaza la palabra "dedos" con una cadena vacía
            var nuevoContenido = contenidoActual.replace('0 selected', 'Seleccionar');

            // Asigna el nuevo contenido al elemento
            elemento.textContent = nuevoContenido;
        });

        let horas = document.getElementById('horas');
        horas.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/[a-zA-Z0-9]/.test(key)) { } else {
                return event.preventDefault();
            }
        });
        horas.addEventListener('input', function () {
            if (this.value.length > 2)
                this.value = this.value.slice(0, 2);
        });
        let tiempo = document.getElementById('tiempo');
        tiempo.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/[a-zA-Z0-9]/.test(key)) { } else {
                return event.preventDefault();
            }
        });
        tiempo.addEventListener('input', function () {
            if (this.value.length > 3)
                this.value = this.value.slice(0, 3);
        });
        let elem = document.getElementById('identificacion');
        elem.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/[a-zA-Z0-9]/.test(key)) { } else {
                return event.preventDefault();
            }
        });
        elem.addEventListener('input', function () {
            if (this.value.length > 15)
                this.value = this.value.slice(0, 15);
        });
        let nombre = document.getElementById('nombre');
        nombre.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/^[a-zA-Z\s]*$/.test(key)) { } else {
                return event.preventDefault();
            }

        });
        nombre.addEventListener('input', function () {
            if (this.value.length > 150)
                this.value = this.value.slice(0, 150);
        });
        // let celular = document.getElementById('edad');
        // celular.addEventListener("keypress", function (event) {
        //     const key = event.key;
        //     if (/[0-9]/.test(key)) { } else {
        //         return event.preventDefault();
        //     }
        // });
        // celular.addEventListener('input', function () {
        //     if (this.value.length > 3)
        //         this.value = this.value.slice(0, 3);
        // });
        // let direccion = document.getElementById('direccion');

        // direccion.addEventListener('input', function () {
        //     if (this.value.length > 250)
        //         this.value = this.value.slice(0, 250);
        // });
        let barrio = document.getElementById('barrio');

        barrio.addEventListener('input', function () {
            if (this.value.length > 250)
                this.value = this.value.slice(0, 250);
        });
        let telefono = document.getElementById('telefono');
        telefono.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/[a-zA-Z0-9]/.test(key)) { } else {
                return event.preventDefault();
            }
        });
        telefono.addEventListener('input', function () {
            if (this.value.length > 10)
                this.value = this.value.slice(0, 10);
        });
        let telefono2 = document.getElementById('telefono2');
        telefono2.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/[a-zA-Z0-9]/.test(key)) { } else {
                return event.preventDefault();
            }
        });
        telefono2.addEventListener('input', function () {
            if (this.value.length > 10)
                this.value = this.value.slice(0, 10);
        });
        let telefono3 = document.getElementById('telefono3');
        telefono3.addEventListener("keypress", function (event) {
            const key = event.key;
            if (/[a-zA-Z0-9]/.test(key)) { } else {
                return event.preventDefault();
            }
        });
        telefono3.addEventListener('input', function () {
            if (this.value.length > 10)
                this.value = this.value.slice(0, 10);
        });

        let diagnostico = document.getElementById('diagnostico');

        diagnostico.addEventListener('input', function () {
            if (this.value.length > 300)
                this.value = this.value.slice(0, 300);
        });
        let cie = document.getElementById('cie');

        cie.addEventListener('input', function () {
            if (this.value.length > 300)
                this.value = this.value.slice(0, 300);
        });
        // let dosis = document.getElementById('dosis');
        // if (dosis) {
        //     dosis.addEventListener('input', function (evt) {
        //         if (this.value.length > 4){
        //             this.value = this.value.slice(0, 4);
        //         }   
        //     });
        // }

        if (document.getElementById('direccionequipos')) {
            let direccionequipos = document.getElementById('direccionequipos');

            direccionequipos.addEventListener('input', function () {
                if (this.value.length > 300)
                    this.value = this.value.slice(0, 300);
            });
        }

        if (document.getElementById('detalleequipos')) {
            let detalleequipos = document.getElementById('detalleequipos');

            detalleequipos.addEventListener('input', function () {
                if (this.value.length > 200)
                    this.value = this.value.slice(0, 200);
            });
        }


    },
}
</script>
<style>
.felchasicono {
    position: absolute;
    right: 2%;
    margin-top: 0.5%;
    font-weight: 800;
}

.b-imagens {
    background: var(--nobel) !important;
    padding: 1% !important;
    margin-top: 2%;
    margin-left: 1%;
    margin-right: 1%;
    cursor: pointer;
}

.butonopcionesMS {
    background: var(--blue-violet-2) !important;
    margin-bottom: 1%;
    margin-top: 1%;
    border: 1px solid var(--blue-violet-2) !important;
    color: white;
    font-weight: 800;
}

.butonopcionesMS:hover {
    background: var(--hover2) !important;
    margin-bottom: 1%;
    margin-top: 1%;
    color: white;
}

.alertaroja {
    margin-top: 2%;
}

/* Campos de homologación - resaltados visualmente para identificarlos */
.campo-homologacion {
    border-left: 4px solid #f0a500 !important;
    background-color: #fff8ed !important;
    border-radius: 6px;
    padding: 10px 12px 8px !important;
    margin-top: 16px !important;
    margin-bottom: 4px;
}

.campo-homologacion .field-label label {
    color: #b36b00 !important;
    font-weight: 700 !important;
}

.campo-homologacion .field-label label::before {
    content: '🔄 ';
}

/* .info::before {
      content: "Seleccionado ";
      display: inline;
    }

    .info div.mainRow.expanded {
    display: none;
    }
    /* .info {
      display: none;
    } */
</style>